/* eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import jsPDF from 'jspdf';
import {
  Form,
  object,
  Formik,
  withRouter,
  invokeEventHandler,
  callOnOpenPreSubmit,
  callOnOpenService,
  handleModalHide,
  parentWindow,
  dataCopyObj,
  showMessage,
  switchToTab,
  useAppContext,
  useHistory,
  useLocation,
  useRouteMatch,
  Modal,
  _kaledo,
  initForm,
  GroupBoxWidget,
  TextBoxWidget,
  DropDownWidget,
  CommandContainerWidget,
  ButtonWidget,
  GridWidget,
  LabelWidget,
  CheckboxWidget,
  getValue,
  setValue,
  show,
  hide,
  setData,
  getData,
  showColumn,
  hideColumn,
  goTo,
  getSelectedRowNumber,
  getGridValue
} from "../../shared/WindowImports";

import "./ExternalReceiptForfeituresSearch.scss";

// START_USER_CODE-USER_IMPORTS
import ContractManagement_header from "../../Header/Header";
import { ContractManagementService } from "../../ContractManagement/Service/ContractManagementService";
import { WarehouseReceiptService } from "../Service/WarehouseReceiptService";
import Loading from "../../../Loader/Loading";
import { GetReportLogoImage } from "../../Common/Constants";
import StripPic from "../../../../assets/img/PinStrip.png";
// END_USER_CODE-USER_IMPORTS
const gridId = 'gridExternalReceiptForfeitureSearchList';

function WarehouseReceipts_ExternalReceiptForfeituresSearch(props) {
  const contextType = useAppContext();
  const screenRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  // START_USER_CODE-USER_PROPERTIES
  const[gettingData,setGettingData] = useState(true)
  // END_USER_CODE-USER_PROPERTIES

  let states = {
    Label: "ExternalReceiptForfeituresSearch",
    windowName: "ExternalReceiptForfeituresSearch",
    template: "Standard Screen",
    Cols: "3",
    ColsForMobile: "3",
    ColsForTabLandscape: "3",
    ColsForTabPotrait: "3",
    is12Column: false,
    isResponsiveLayout: false,
    Height: "",
    Left: "",
    Top: "",
    Width: "",
    i18Key: "WarehouseReceipts.ExternalReceiptForfeituresSearch",
    // START_USER_CODE-USER_ExternalReceiptForfeituresSearch_PROPERTIES
    horizontalForm: true,
    headerData: {
      scrName: "External Receipt Forfeitures Search",
      scrCode: "PN1090P",
    },
    // END_USER_CODE-USER_ExternalReceiptForfeituresSearch_PROPERTIES
    btnClose: {
      name: "btnClose",
      type: "ButtonWidget",
      parent: "cmmndCntnrActions",
      Label: "Close",
      CharWidth: "13",

      ofTypeDomain: "d_boolean",
      // START_USER_CODE-USER_btnClose_PROPERTIES

      // END_USER_CODE-USER_btnClose_PROPERTIES
    },
    btnCreate: {
      name: "btnCreate",
      type: "ButtonWidget",
      parent: "grpbxSearchList",
      Label: "Create",
      CharWidth: "15",

      ofTypeDomain: "d_boolean",
      // START_USER_CODE-USER_btnCreate_PROPERTIES

      // END_USER_CODE-USER_btnCreate_PROPERTIES
    },
    btnOpen: {
      name: "btnOpen",
      type: "ButtonWidget",
      parent: "grpbxSearchList",
      Label: "Open",
      CharWidth: "11",

      ofTypeDomain: "d_boolean",
      // START_USER_CODE-USER_btnOpen_PROPERTIES

      // END_USER_CODE-USER_btnOpen_PROPERTIES
    },
    btnPrintSearch: {
      name: "btnPrintSearch",
      type: "ButtonWidget",
      parent: "cmmndCntnrActions",
      Label: "Print Search",
      CharWidth: "26",

      ofTypeDomain: "d_boolean",
      // START_USER_CODE-USER_btnPrintSearch_PROPERTIES

      // END_USER_CODE-USER_btnPrintSearch_PROPERTIES
    },
    btnSearch: {
      name: "btnSearch",
      type: "ButtonWidget",
      parent: "grpbxSearchList",
      Label: "Search",
      CharWidth: "15",

      ofTypeDomain: "d_boolean",
      // START_USER_CODE-USER_btnSearch_PROPERTIES

      // END_USER_CODE-USER_btnSearch_PROPERTIES
    },
    chkboxShowAllFields: {
      name: "chkboxShowAllFields",
      type: "CheckBoxWidget",
      parent: "grpbxSearchList",
      Label: "Show All Fields",
      HasLabel: false,

      ofTypeDomain: "d_boolean",
      // START_USER_CODE-USER_chkboxShowAllFields_PROPERTIES

      // END_USER_CODE-USER_chkboxShowAllFields_PROPERTIES
    },
    colBuyingPointName: {
      name: "colBuyingPointName",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Buying Point Name",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colBuyingPointName_PROPERTIES

      // END_USER_CODE-USER_colBuyingPointName_PROPERTIES
    },
    colBuyingPointNum: {
      name: "colBuyingPointNum",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Buying Point #",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colBuyingPointNum_PROPERTIES

      // END_USER_CODE-USER_colBuyingPointNum_PROPERTIES
    },
    colCancelDateTime: {
      name: "colCancelDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cancel_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCancelDateTime_PROPERTIES

      // END_USER_CODE-USER_colCancelDateTime_PROPERTIES
    },
    colCancelUser: {
      name: "colCancelUser",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cancel_user",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCancelUser_PROPERTIES

      // END_USER_CODE-USER_colCancelUser_PROPERTIES
    },
    colCCCErrorCode: {
      name: "colCCCErrorCode",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "ccc_error_code",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCCCErrorCode_PROPERTIES

      // END_USER_CODE-USER_colCCCErrorCode_PROPERTIES
    },
    colCCCLoanStatus: {
      name: "colCCCLoanStatus",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "ccc_loan_status",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCCCLoanStatus_PROPERTIES

      // END_USER_CODE-USER_colCCCLoanStatus_PROPERTIES
    },
    colChgDateTime: {
      name: "colChgDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "chg_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colChgDateTime_PROPERTIES

      // END_USER_CODE-USER_colChgDateTime_PROPERTIES
    },
    colChgUser: {
      name: "colChgUser",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "chg_user",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colChgUser_PROPERTIES

      // END_USER_CODE-USER_colChgUser_PROPERTIES
    },
    colClnChrgAmt: {
      name: "colClnChrgAmt",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cln_chrg_amt",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colClnChrgAmt_PROPERTIES

      // END_USER_CODE-USER_colClnChrgAmt_PROPERTIES
    },
    colClnDryChrgAmt: {
      name: "colClnDryChrgAmt",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cln_dry_chrg_amt",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colClnDryChrgAmt_PROPERTIES

      // END_USER_CODE-USER_colClnDryChrgAmt_PROPERTIES
    },
    colClnDryPerTon: {
      name: "colClnDryPerTon",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cln_dry_per_ton",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colClnDryPerTon_PROPERTIES

      // END_USER_CODE-USER_colClnDryPerTon_PROPERTIES
    },
    colCnclRmdPct: {
      name: "colCnclRmdPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cncl_rmd_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCnclRmdPct_PROPERTIES

      // END_USER_CODE-USER_colCnclRmdPct_PROPERTIES
    },
    colCnlPerTon: {
      name: "colCnlPerTon",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cnl_per_ton",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCnlPerTon_PROPERTIES

      // END_USER_CODE-USER_colCnlPerTon_PROPERTIES
    },
    colCrBrPct: {
      name: "colCrBrPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cr_br_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCrBrPct_PROPERTIES

      // END_USER_CODE-USER_colCrBrPct_PROPERTIES
    },
    colCurHolderDateTime: {
      name: "colCurHolderDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cur_holder_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCurHolderDateTime_PROPERTIES

      // END_USER_CODE-USER_colCurHolderDateTime_PROPERTIES
    },
    colCurrHolder: {
      name: "colCurrHolder",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "cur_holder",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCurrHolder_PROPERTIES

      // END_USER_CODE-USER_colCurrHolder_PROPERTIES
    },
    colCurrHolderName: {
      name: "colCurrHolderName",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "curr_holder_name",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colCurrHolderName_PROPERTIES

      // END_USER_CODE-USER_colCurrHolderName_PROPERTIES
    },
    colDamKrsPct: {
      name: "colDamKrsPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "dam_krs_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDamKrsPct_PROPERTIES

      // END_USER_CODE-USER_colDamKrsPct_PROPERTIES
    },
    colDamSPct: {
      name: "colDamSPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "dam_s_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDamSPct_PROPERTIES

      // END_USER_CODE-USER_colDamSPct_PROPERTIES
    },
    colDcolShelPct: {
      name: "colDcolShelPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "dcol_shel_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDcolShelPct_PROPERTIES

      // END_USER_CODE-USER_colDcolShelPct_PROPERTIES
    },
    colDelvAgreeCompId: {
      name: "colDelvAgreeCompId",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "delv_agree_comp_id",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDelvAgreeCompId_PROPERTIES

      // END_USER_CODE-USER_colDelvAgreeCompId_PROPERTIES
    },
    colDelvAgreeCropYear: {
      name: "colDelvAgreeCropYear",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "delv_agree_crop_year",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDelvAgreeCropYear_PROPERTIES

      // END_USER_CODE-USER_colDelvAgreeCropYear_PROPERTIES
    },
    colDelvAgreeNum: {
      name: "colDelvAgreeNum",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "delv_agree_num",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDelvAgreeNum_PROPERTIES

      // END_USER_CODE-USER_colDelvAgreeNum_PROPERTIES
    },
    colDepositorName: {
      name: "colDepositorName",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "depositor_name",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDepositorName_PROPERTIES

      // END_USER_CODE-USER_colDepositorName_PROPERTIES
    },
    colDPSCounty: {
      name: "colDPSCounty",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "dps_county",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDPSCounty_PROPERTIES

      // END_USER_CODE-USER_colDPSCounty_PROPERTIES
    },
    colDPSState: {
      name: "colDPSState",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "dps_state",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDPSState_PROPERTIES

      // END_USER_CODE-USER_colDPSState_PROPERTIES
    },
    colDryChrgAmt: {
      name: "colDryChrgAmt",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "dry_chrg_amt",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDryChrgAmt_PROPERTIES

      // END_USER_CODE-USER_colDryChrgAmt_PROPERTIES
    },
    colDryPerTon: {
      name: "colDryPerTon",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "dry_per_ton",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colDryPerTon_PROPERTIES

      // END_USER_CODE-USER_colDryPerTon_PROPERTIES
    },
    colElectronicPaperInd: {
      name: "colElectronicPaperInd",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "electronic_paper_ind",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colElectronicPaperInd_PROPERTIES

      // END_USER_CODE-USER_colElectronicPaperInd_PROPERTIES
    },
    colElkPct: {
      name: "colElkPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "elk_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colElkPct_PROPERTIES

      // END_USER_CODE-USER_colElkPct_PROPERTIES
    },
    colEWRChgDateTime: {
      name: "colEWRChgDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "ewr_chg_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colEWRChgDateTime_PROPERTIES

      // END_USER_CODE-USER_colEWRChgDateTime_PROPERTIES
    },
    colEWRChgUser: {
      name: "colEWRChgUser",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "ewr_chg_user",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colEWRChgUser_PROPERTIES

      // END_USER_CODE-USER_colEWRChgUser_PROPERTIES
    },
    colEWRCropYear: {
      name: "colEWRCropYear",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "ewr_crop_year",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colEWRCropYear_PROPERTIES

      // END_USER_CODE-USER_colEWRCropYear_PROPERTIES
    },
    colEWRRcptStatus: {
      name: "colEWRRcptStatus",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "ewr_rcpt_status",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colEWRRcptStatus_PROPERTIES

      // END_USER_CODE-USER_colEWRRcptStatus_PROPERTIES
    },
    colFanPct: {
      name: "colFanPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "fan_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colFanPct_PROPERTIES

      // END_USER_CODE-USER_colFanPct_PROPERTIES
    },
    colFarmCounty: {
      name: "colFarmCounty",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Farm County",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colFarmCounty_PROPERTIES

      // END_USER_CODE-USER_colFarmCounty_PROPERTIES
    },
    colFarmNum: {
      name: "colFarmNum",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Farm #",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colFarmNum_PROPERTIES

      // END_USER_CODE-USER_colFarmNum_PROPERTIES
    },
    colFarmState: {
      name: "colFarmState",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Farm State",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colFarmState_PROPERTIES

      // END_USER_CODE-USER_colFarmState_PROPERTIES
    },
    colFlavusInd: {
      name: "colFlavusInd",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "flavus_ind",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colFlavusInd_PROPERTIES

      // END_USER_CODE-USER_colFlavusInd_PROPERTIES
    },
    colFmPct: {
      name: "colFmPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "fm_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colFmPct_PROPERTIES

      // END_USER_CODE-USER_colFmPct_PROPERTIES
    },
    colFrezDamPct: {
      name: "colFrezDamPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "frez_dam_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colFrezDamPct_PROPERTIES

      // END_USER_CODE-USER_colFrezDamPct_PROPERTIES
    },
    colGradingInd: {
      name: "colGradingInd",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "grading_ind",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colGradingInd_PROPERTIES

      // END_USER_CODE-USER_colGradingInd_PROPERTIES
    },
    colGrowerHolder: {
      name: "colGrowerHolder",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "grower_holder",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colGrowerHolder_PROPERTIES

      // END_USER_CODE-USER_colGrowerHolder_PROPERTIES
    },
    colHaulChrgAmt: {
      name: "colHaulChrgAmt",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "haul_chrg_amt",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colHaulChrgAmt_PROPERTIES

      // END_USER_CODE-USER_colHaulChrgAmt_PROPERTIES
    },
    colHaulPerTon: {
      name: "colHaulPerTon",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "haul_per_ton",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colHaulPerTon_PROPERTIES

      // END_USER_CODE-USER_colHaulPerTon_PROPERTIES
    },
    colHulKernPct: {
      name: "colHulKernPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "hul_kern_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colHulKernPct_PROPERTIES

      // END_USER_CODE-USER_colHulKernPct_PROPERTIES
    },
    colHulPct: {
      name: "colHulPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "hul_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colHulPct_PROPERTIES

      // END_USER_CODE-USER_colHulPct_PROPERTIES
    },
    colInsuredInd: {
      name: "colInsuredInd",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "insured_ind",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colInsuredInd_PROPERTIES

      // END_USER_CODE-USER_colInsuredInd_PROPERTIES
    },
    colIssuedDateTime: {
      name: "colIssuedDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "issued_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colIssuedDateTime_PROPERTIES

      // END_USER_CODE-USER_colIssuedDateTime_PROPERTIES
    },
    colIssuedUser: {
      name: "colIssuedUser",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "issued_user",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colIssuedUser_PROPERTIES

      // END_USER_CODE-USER_colIssuedUser_PROPERTIES
    },
    colKrsPct: {
      name: "colKrsPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "krs_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colKrsPct_PROPERTIES

      // END_USER_CODE-USER_colKrsPct_PROPERTIES
    },
    colLoadinChrgRate: {
      name: "colLoadinChrgRate",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loadin_chrg_rate",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoadinChrgRate_PROPERTIES

      // END_USER_CODE-USER_colLoadinChrgRate_PROPERTIES
    },
    colLoadingRateBase: {
      name: "colLoadingRateBase",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loading_rate_base",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoadingRateBase_PROPERTIES

      // END_USER_CODE-USER_colLoadingRateBase_PROPERTIES
    },
    colLoadinPaidInd: {
      name: "colLoadinPaidInd",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loadin_paid_ind",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoadinPaidInd_PROPERTIES

      // END_USER_CODE-USER_colLoadinPaidInd_PROPERTIES
    },
    colLoanable: {
      name: "colLoanable",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loanable",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanable_PROPERTIES

      // END_USER_CODE-USER_colLoanable_PROPERTIES
    },
    colLoanApplicationDate: {
      name: "colLoanApplicationDate",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loan_application_date",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanApplicationDate_PROPERTIES

      // END_USER_CODE-USER_colLoanApplicationDate_PROPERTIES
    },
    colLoanApproveDateTime: {
      name: "colLoanApproveDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loan_approve_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanApproveDateTime_PROPERTIES

      // END_USER_CODE-USER_colLoanApproveDateTime_PROPERTIES
    },
    colLoanDisbursementDate: {
      name: "colLoanDisbursementDate",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loan_disbursement_date",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanDisbursementDate_PROPERTIES

      // END_USER_CODE-USER_colLoanDisbursementDate_PROPERTIES
    },
    colLoanIDPType: {
      name: "colLoanIDPType",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loan_ldp_type",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanIDPType_PROPERTIES

      // END_USER_CODE-USER_colLoanIDPType_PROPERTIES
    },
    colLoanIDPUser: {
      name: "colLoanIDPUser",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loan_ldp_user",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanIDPUser_PROPERTIES

      // END_USER_CODE-USER_colLoanIDPUser_PROPERTIES
    },
    colLoanNum: {
      name: "colLoanNum",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loan_number",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanNum_PROPERTIES

      // END_USER_CODE-USER_colLoanNum_PROPERTIES
    },
    colLoanReceivedDate: {
      name: "colLoanReceivedDate",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loan_received_date",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanReceivedDate_PROPERTIES

      // END_USER_CODE-USER_colLoanReceivedDate_PROPERTIES
    },
    colLoanRelDateTime: {
      name: "colLoanRelDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loan_rel_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanRelDateTime_PROPERTIES

      // END_USER_CODE-USER_colLoanRelDateTime_PROPERTIES
    },
    colLoanRepaymentDate: {
      name: "colLoanRepaymentDate",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "loan_repayment_date",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLoanRepaymentDate_PROPERTIES

      // END_USER_CODE-USER_colLoanRepaymentDate_PROPERTIES
    },
    colLotNum: {
      name: "colLotNum",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "lot_number",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLotNum_PROPERTIES

      // END_USER_CODE-USER_colLotNum_PROPERTIES
    },
    colLskLbs: {
      name: "colLskLbs",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "lsk_lbs",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLskLbs_PROPERTIES

      // END_USER_CODE-USER_colLskLbs_PROPERTIES
    },
    colLskTons: {
      name: "colLskTons",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "lsk_tons",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colLskTons_PROPERTIES

      // END_USER_CODE-USER_colLskTons_PROPERTIES
    },
    colMoistPct: {
      name: "colMoistPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "moist_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colMoistPct_PROPERTIES

      // END_USER_CODE-USER_colMoistPct_PROPERTIES
    },
    colNegotInd: {
      name: "colNegotInd",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "negotiable_ind",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colNegotInd_PROPERTIES

      // END_USER_CODE-USER_colNegotInd_PROPERTIES
    },
    colNetLbs: {
      name: "colNetLbs",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "net_lbs",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colNetLbs_PROPERTIES

      // END_USER_CODE-USER_colNetLbs_PROPERTIES
    },
    colNetTons: {
      name: "colNetTons",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "net_tons",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colNetTons_PROPERTIES

      // END_USER_CODE-USER_colNetTons_PROPERTIES
    },
    colOkPct: {
      name: "colOkPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "ok_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colOkPct_PROPERTIES

      // END_USER_CODE-USER_colOkPct_PROPERTIES
    },
    colOthChrgAmt: {
      name: "colOthChrgAmt",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "oth_chrg_amt",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colOthChrgAmt_PROPERTIES

      // END_USER_CODE-USER_colOthChrgAmt_PROPERTIES
    },
    colOtherPerTon: {
      name: "colOtherPerTon",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "other_per_ton",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colOtherPerTon_PROPERTIES

      // END_USER_CODE-USER_colOtherPerTon_PROPERTIES
    },
    colPaperCntlNum: {
      name: "colPaperCntlNum",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "paper_cntl_num",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPaperCntlNum_PROPERTIES

      // END_USER_CODE-USER_colPaperCntlNum_PROPERTIES
    },
    colPaperRcptNum: {
      name: "colPaperRcptNum",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "paper_rcpt_num",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPaperRcptNum_PROPERTIES

      // END_USER_CODE-USER_colPaperRcptNum_PROPERTIES
    },
    colParentWhseCity: {
      name: "colParentWhseCity",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "parent_whse_city",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colParentWhseCity_PROPERTIES

      // END_USER_CODE-USER_colParentWhseCity_PROPERTIES
    },
    colParentWhseState: {
      name: "colParentWhseState",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "parent_whse_state",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colParentWhseState_PROPERTIES

      // END_USER_CODE-USER_colParentWhseState_PROPERTIES
    },
    colPayoffAmount: {
      name: "colPayoffAmount",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "payoff_amount",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPayoffAmount_PROPERTIES

      // END_USER_CODE-USER_colPayoffAmount_PROPERTIES
    },
    colPayoffBuyPt: {
      name: "colPayoffBuyPt",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "payoff_buy_pt",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPayoffBuyPt_PROPERTIES

      // END_USER_CODE-USER_colPayoffBuyPt_PROPERTIES
    },
    colPayoffDateTime: {
      name: "colPayoffDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "payoff_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPayoffDateTime_PROPERTIES

      // END_USER_CODE-USER_colPayoffDateTime_PROPERTIES
    },
    colPayoffRemit: {
      name: "colPayoffRemit",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "payoff_remit",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPayoffRemit_PROPERTIES

      // END_USER_CODE-USER_colPayoffRemit_PROPERTIES
    },
    colPayoffVendor: {
      name: "colPayoffVendor",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "payoff_vendor",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPayoffVendor_PROPERTIES

      // END_USER_CODE-USER_colPayoffVendor_PROPERTIES
    },
    colPeanutTypeID: {
      name: "colPeanutTypeID",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Peanut Type ID",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPeanutTypeID_PROPERTIES

      // END_USER_CODE-USER_colPeanutTypeID_PROPERTIES
    },
    colPrevHoldchgDateTime: {
      name: "colPrevHoldchgDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "prev_hold_chg_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPrevHoldchgDateTime_PROPERTIES

      // END_USER_CODE-USER_colPrevHoldchgDateTime_PROPERTIES
    },
    colPrevHolder: {
      name: "colPrevHolder",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "prev_holder",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPrevHolder_PROPERTIES

      // END_USER_CODE-USER_colPrevHolder_PROPERTIES
    },
    colPrevHolderName: {
      name: "colPrevHolderName",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "prev_holder_name",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colPrevHolderName_PROPERTIES

      // END_USER_CODE-USER_colPrevHolderName_PROPERTIES
    },
    colProducerName: {
      name: "colProducerName",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Producer Name",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colProducerName_PROPERTIES

      // END_USER_CODE-USER_colProducerName_PROPERTIES
    },
    colReceiptNum: {
      name: "colReceiptNum",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Receipt #",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colReceiptNum_PROPERTIES

      // END_USER_CODE-USER_colReceiptNum_PROPERTIES
    },
    colReceiptValue: {
      name: "colReceiptValue",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Receipt Value",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colReceiptValue_PROPERTIES

      // END_USER_CODE-USER_colReceiptValue_PROPERTIES
    },
    colRecordStatus: {
      name: "colRecordStatus",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Record Status",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colRecordStatus_PROPERTIES

      // END_USER_CODE-USER_colRecordStatus_PROPERTIES
    },
    colRelToDateTime: {
      name: "colRelToDateTime",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "rel_to_date_time",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colRelToDateTime_PROPERTIES

      // END_USER_CODE-USER_colRelToDateTime_PROPERTIES
    },
    colRelToHolder: {
      name: "colRelToHolder",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "rel_to_holder",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colRelToHolder_PROPERTIES

      // END_USER_CODE-USER_colRelToHolder_PROPERTIES
    },
    colRelToWhseCode: {
      name: "colRelToWhseCode",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "rel_to_whse_code",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colRelToWhseCode_PROPERTIES

      // END_USER_CODE-USER_colRelToWhseCode_PROPERTIES
    },
    colSegType: {
      name: "colSegType",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "seg_type",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colSegType_PROPERTIES

      // END_USER_CODE-USER_colSegType_PROPERTIES
    },
    colSmkRsPct: {
      name: "colSmkRsPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "smk_rs_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colSmkRsPct_PROPERTIES

      // END_USER_CODE-USER_colSmkRsPct_PROPERTIES
    },
    colSSPct: {
      name: "colSSPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "ss_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colSSPct_PROPERTIES

      // END_USER_CODE-USER_colSSPct_PROPERTIES
    },
    colStorageCity: {
      name: "colStorageCity",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "storage_city",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colStorageCity_PROPERTIES

      // END_USER_CODE-USER_colStorageCity_PROPERTIES
    },
    colStorageContainer: {
      name: "colStorageContainer",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "storage_container",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colStorageContainer_PROPERTIES

      // END_USER_CODE-USER_colStorageContainer_PROPERTIES
    },
    colStorageDate: {
      name: "colStorageDate",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "storage_date",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colStorageDate_PROPERTIES

      // END_USER_CODE-USER_colStorageDate_PROPERTIES
    },
    colStorageState: {
      name: "colStorageState",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "storage_state",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colStorageState_PROPERTIES

      // END_USER_CODE-USER_colStorageState_PROPERTIES
    },
    colStorageStatus: {
      name: "colStorageStatus",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "storage_staus",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colStorageStatus_PROPERTIES

      // END_USER_CODE-USER_colStorageStatus_PROPERTIES
    },
    colSubHolder: {
      name: "colSubHolder",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "sub_holder",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colSubHolder_PROPERTIES

      // END_USER_CODE-USER_colSubHolder_PROPERTIES
    },
    colTotalLbs: {
      name: "colTotalLbs",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Total Lbs",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colTotalLbs_PROPERTIES

      // END_USER_CODE-USER_colTotalLbs_PROPERTIES
    },
    colTotalTons: {
      name: "colTotalTons",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "total_tons",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colTotalTons_PROPERTIES

      // END_USER_CODE-USER_colTotalTons_PROPERTIES
    },
    colTotDamPct: {
      name: "colTotDamPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "tot_dam_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colTotDamPct_PROPERTIES

      // END_USER_CODE-USER_colTotDamPct_PROPERTIES
    },
    colTotKernPct: {
      name: "colTotKernPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "tot_kern_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colTotKernPct_PROPERTIES

      // END_USER_CODE-USER_colTotKernPct_PROPERTIES
    },
    colTotSmkPct: {
      name: "colTotSmkPct",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "tot_smk_pct",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colTotSmkPct_PROPERTIES

      // END_USER_CODE-USER_colTotSmkPct_PROPERTIES
    },
    colTradeAccount: {
      name: "colTradeAccount",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "trade_account",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colTradeAccount_PROPERTIES

      // END_USER_CODE-USER_colTradeAccount_PROPERTIES
    },
    colManualIndicator: {
      name: "colManualIndicator",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Manual Indicator",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colManualIndicator_PROPERTIES

      // END_USER_CODE-USER_colManualIndicator_PROPERTIES
    },
    colManualAddUser: {
      name: "colManualAddUser",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Manual Add User",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colManualAddUser_PROPERTIES

      // END_USER_CODE-USER_colManualAddUser_PROPERTIES
    },
    colManualAddDate: {
      name: "colManualAddDate",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Manual Add Date",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colManualAddDate_PROPERTIES

      // END_USER_CODE-USER_colManualAddDate_PROPERTIES
    },
    colMax: {
      name: "colMax",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "Max",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colMax_PROPERTIES

      // END_USER_CODE-USER_colMax_PROPERTIES
    },
    colTradeCategory: {
      name: "colTradeCategory",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "trade_category",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colTradeCategory_PROPERTIES

      // END_USER_CODE-USER_colTradeCategory_PROPERTIES
    },
    colUserDefined: {
      name: "colUserDefined",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "user_defined",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colUserDefined_PROPERTIES

      // END_USER_CODE-USER_colUserDefined_PROPERTIES
    },
    colWarehouseCode: {
      name: "colWarehouseCode",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "WareHouse Code",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colWarehouseCode_PROPERTIES

      // END_USER_CODE-USER_colWarehouseCode_PROPERTIES
    },
    colWhseDepositorInd: {
      name: "colWhseDepositorInd",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "whse_depositor_ind",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colWhseDepositorInd_PROPERTIES

      // END_USER_CODE-USER_colWhseDepositorInd_PROPERTIES
    },
    colWhseLicNum: {
      name: "colWhseLicNum",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "whse_license_num",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colWhseLicNum_PROPERTIES

      // END_USER_CODE-USER_colWhseLicNum_PROPERTIES
    },
    colWhseOperator: {
      name: "colWhseOperator",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "whse_operator",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colWhseOperator_PROPERTIES

      // END_USER_CODE-USER_colWhseOperator_PROPERTIES
    },
    colWhseSignature: {
      name: "colWhseSignature",
      type: "GridColumnWidget",
      parent: "gridExternalReceiptForfeitureSearchList",
      Label: "whse_signature",
      Height: "",
      Width: "",
      // START_USER_CODE-USER_colWhseSignature_PROPERTIES

      // END_USER_CODE-USER_colWhseSignature_PROPERTIES
    },
    ddPeanutType: {
      name: "ddPeanutType",
      type: "DropDownFieldWidget",
      parent: "grpbxDetails",
      Label: "Peanut Type:",
      DataProviderForDropDown: "inline",

      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_ddPeanutType_PROPERTIES

      // END_USER_CODE-USER_ddPeanutType_PROPERTIES
    },
    ddRecordStatus: {
      name: "ddRecordStatus",
      type: "DropDownFieldWidget",
      parent: "grpbxDetails",
      Label: "Record Status:",
      ColSpan: "2",
      DataProviderForDropDown: "inline",

      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_ddRecordStatus_PROPERTIES

      // END_USER_CODE-USER_ddRecordStatus_PROPERTIES
    },
    gridExternalReceiptForfeitureSearchList: {
      name: "gridExternalReceiptForfeitureSearchList",
      type: "GridWidget",
      parent: "grpbxSearchList",
      gridCellsOrder:
        "txtcolReceiptNum,txtcolRecordStatus,txtcolTotalLbs,txtcolFarmState,txtcolFarmCounty,txtcolFarmNum,txtcolProducerName,txtcolPeanutTypeID,txtcolBuyingPointNum,txtcolBuyingPointName,txtcolReceiptValue,txtcolWarehouseCode,txtcolWhseLicNum,txtcolNegotInd,txtcolInsuredInd,txtcolPaperRcptNum,txtcolNetLbs,txtcolNetTons,txtcolLskLbs,txtcolLskTons,txtcolTotalTons,txtcolStorageDate,txtcolStorageContainer,txtcolStorageStatus,txtcolParentWhseCity,txtcolParentWhseState,txtcolDepositorName,txtcolStorageCity,txtcolStorageState,txtcolLoadinChrgRate,txtcolLoadinPaidInd,txtcolLoadingRateBase,txtcolGradingInd,txtcolSegType,txtcolMoistPct,txtcolFmPct,txtcolElkPct,txtcolCrBrPct,txtcolDcolShelPct,txtcolLotNum,txtcolKrsPct,txtcolDamKrsPct,txtcolSmkRsPct,txtcolSSPct,txtcolTotSmkPct,txtcolOkPct,txtcolDamSPct,txtcolTotDamPct,txtcolTotKernPct,txtcolHulPct,txtcolFlavusInd,txtcolHulKernPct,txtcolFrezDamPct,txtcolCnclRmdPct,txtcolWhseDepositorInd,txtcolWhseOperator,txtcolWhseSignature,txtcolPaperCntlNum,txtcolCnlPerTon,txtcolDryPerTon,txtcolClnDryPerTon,txtcolHaulPerTon,txtcolOtherPerTon,txtcolClnChrgAmt,txtcolDryChrgAmt,txtcolClnDryChrgAmt,txtcolHaulChrgAmt,txtcolOthChrgAmt,txtcolDPSState,txtcolDPSCounty,txtcolLoanNum,txtcolCurrHolder,txtcolCurHolderDateTime,txtcolSubHolder,txtcolPrevHolder,txtcolEWRRcptStatus,txtcolElectronicPaperInd,txtcolCCCLoanStatus,txtcolIssuedDateTime,txtcolCancelDateTime,txtcolEWRChgDateTime,txtcolLoanApproveDateTime,txtcolLoanRelDateTime,txtcolIssuedUser,txtcolCancelUser,txtcolEWRChgUser,txtcolLoanIDPUser,txtcolGrowerHolder,txtcolLoanable,txtcolLoanIDPType,txtcolPrevHoldchgDateTime,txtcolCurrHolderName,txtcolPrevHolderName,txtcolLoanDisbursementDate,txtcolLoanApplicationDate,txtcolLoanRepaymentDate,txtcolLoanReceivedDate,txtcolCCCErrorCode,txtcolUserDefined,txtcolPayoffAmount,txtcolPayoffVendor,txtcolPayoffRemit,txtcolPayoffDateTime,txtcolRelToHolder,txtcolRelToWhseCode,txtcolRelToDateTime,txtcolDelvAgreeCompId,txtcolDelvAgreeCropYear,txtcolDelvAgreeNum,txtcolChgUser,txtcolChgDateTime,txtcolFanPct,txtcolPayoffBuyPt,txtcolEWRCropYear,txtcolTradeCategory,txtcolTradeAccount,txtcolManualIndicator,txtcolManualAddUser,txtcolManualAddDate,txtcolMax",
      ColSpan: "6",
      Pagination: false,
      HasLabel: false,
      Height: "",
      Width: "",
      // START_USER_CODE-USER_gridExternalReceiptForfeitureSearchList_PROPERTIES

      // END_USER_CODE-USER_gridExternalReceiptForfeitureSearchList_PROPERTIES
    },
    grpbxDetails: {
      name: "grpbxDetails",
      type: "GroupBoxWidget",
      parent: "grpbxExternalReceiptForfeituresSearch",
      Height: "",
      Width: "",
      HasLabel: false,
      Cols: "2",
      // START_USER_CODE-USER_grpbxDetails_PROPERTIES

      // END_USER_CODE-USER_grpbxDetails_PROPERTIES
    },
    grpbxSearchList: {
      name: "grpbxSearchList",
      type: "GroupBoxWidget",
      parent: "grpbxExternalReceiptForfeituresSearch",
      Height: "",
      Width: "",
      ColsForMobile: "6",
      ColsForTabLandscape: "6",
      HasLabel: false,
      Cols: "6",
      ColsForTabPotrait: "6",
      ColsForLargeDesktop: "6",
      // START_USER_CODE-USER_grpbxSearchList_PROPERTIES

      // END_USER_CODE-USER_grpbxSearchList_PROPERTIES
    },
    lblCropYear: {
      name: "lblCropYear",
      type: "LabelWidget",
      parent: "grpbxSearchList",
      Label: "Crop Year:",
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_lblCropYear_PROPERTIES

      // END_USER_CODE-USER_lblCropYear_PROPERTIES
    },
    lblExternalReceiptForfeitureSearchList: {
      name: "lblExternalReceiptForfeitureSearchList",
      type: "LabelWidget",
      parent: "grpbxSearchList",
      Label: "External Receipt Forfeiture Search List:",
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_lblExternalReceiptForfeitureSearchList_PROPERTIES

      // END_USER_CODE-USER_lblExternalReceiptForfeitureSearchList_PROPERTIES
    },
    txtcolBuyingPointName: {
      name: "txtcolBuyingPointName",
      type: "TextBoxWidget",
      colName: "colBuyingPointName",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolBuyingPointName_PROPERTIES

      // END_USER_CODE-USER_txtcolBuyingPointName_PROPERTIES
    },
    txtcolBuyingPointNum: {
      name: "txtcolBuyingPointNum",
      type: "TextBoxWidget",
      colName: "colBuyingPointNum",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolBuyingPointNum_PROPERTIES

      // END_USER_CODE-USER_txtcolBuyingPointNum_PROPERTIES
    },
    txtcolCancelDateTime: {
      name: "txtcolCancelDateTime",
      type: "TextBoxWidget",
      colName: "colCancelDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCancelDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolCancelDateTime_PROPERTIES
    },
    txtcolCancelUser: {
      name: "txtcolCancelUser",
      type: "TextBoxWidget",
      colName: "colCancelUser",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCancelUser_PROPERTIES

      // END_USER_CODE-USER_txtcolCancelUser_PROPERTIES
    },
    txtcolCCCErrorCode: {
      name: "txtcolCCCErrorCode",
      type: "TextBoxWidget",
      colName: "colCCCErrorCode",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCCCErrorCode_PROPERTIES

      // END_USER_CODE-USER_txtcolCCCErrorCode_PROPERTIES
    },
    txtcolCCCLoanStatus: {
      name: "txtcolCCCLoanStatus",
      type: "TextBoxWidget",
      colName: "colCCCLoanStatus",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCCCLoanStatus_PROPERTIES

      // END_USER_CODE-USER_txtcolCCCLoanStatus_PROPERTIES
    },
    txtcolChgDateTime: {
      name: "txtcolChgDateTime",
      type: "TextBoxWidget",
      colName: "colChgDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolChgDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolChgDateTime_PROPERTIES
    },
    txtcolChgUser: {
      name: "txtcolChgUser",
      type: "TextBoxWidget",
      colName: "colChgUser",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolChgUser_PROPERTIES

      // END_USER_CODE-USER_txtcolChgUser_PROPERTIES
    },
    txtcolClnChrgAmt: {
      name: "txtcolClnChrgAmt",
      type: "TextBoxWidget",
      colName: "colClnChrgAmt",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolClnChrgAmt_PROPERTIES

      // END_USER_CODE-USER_txtcolClnChrgAmt_PROPERTIES
    },
    txtcolClnDryChrgAmt: {
      name: "txtcolClnDryChrgAmt",
      type: "TextBoxWidget",
      colName: "colClnDryChrgAmt",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolClnDryChrgAmt_PROPERTIES

      // END_USER_CODE-USER_txtcolClnDryChrgAmt_PROPERTIES
    },
    txtcolClnDryPerTon: {
      name: "txtcolClnDryPerTon",
      type: "TextBoxWidget",
      colName: "colClnDryPerTon",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolClnDryPerTon_PROPERTIES

      // END_USER_CODE-USER_txtcolClnDryPerTon_PROPERTIES
    },
    txtcolCnclRmdPct: {
      name: "txtcolCnclRmdPct",
      type: "TextBoxWidget",
      colName: "colCnclRmdPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCnclRmdPct_PROPERTIES

      // END_USER_CODE-USER_txtcolCnclRmdPct_PROPERTIES
    },
    txtcolCnlPerTon: {
      name: "txtcolCnlPerTon",
      type: "TextBoxWidget",
      colName: "colCnlPerTon",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCnlPerTon_PROPERTIES

      // END_USER_CODE-USER_txtcolCnlPerTon_PROPERTIES
    },
    txtcolCrBrPct: {
      name: "txtcolCrBrPct",
      type: "TextBoxWidget",
      colName: "colCrBrPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCrBrPct_PROPERTIES

      // END_USER_CODE-USER_txtcolCrBrPct_PROPERTIES
    },
    txtcolCurHolderDateTime: {
      name: "txtcolCurHolderDateTime",
      type: "TextBoxWidget",
      colName: "colCurHolderDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCurHolderDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolCurHolderDateTime_PROPERTIES
    },
    txtcolCurrHolder: {
      name: "txtcolCurrHolder",
      type: "TextBoxWidget",
      colName: "colCurrHolder",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCurrHolder_PROPERTIES

      // END_USER_CODE-USER_txtcolCurrHolder_PROPERTIES
    },
    txtcolCurrHolderName: {
      name: "txtcolCurrHolderName",
      type: "TextBoxWidget",
      colName: "colCurrHolderName",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolCurrHolderName_PROPERTIES

      // END_USER_CODE-USER_txtcolCurrHolderName_PROPERTIES
    },
    txtcolDamKrsPct: {
      name: "txtcolDamKrsPct",
      type: "TextBoxWidget",
      colName: "colDamKrsPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDamKrsPct_PROPERTIES

      // END_USER_CODE-USER_txtcolDamKrsPct_PROPERTIES
    },
    txtcolDamSPct: {
      name: "txtcolDamSPct",
      type: "TextBoxWidget",
      colName: "colDamSPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDamSPct_PROPERTIES

      // END_USER_CODE-USER_txtcolDamSPct_PROPERTIES
    },
    txtcolDcolShelPct: {
      name: "txtcolDcolShelPct",
      type: "TextBoxWidget",
      colName: "colDcolShelPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDcolShelPct_PROPERTIES

      // END_USER_CODE-USER_txtcolDcolShelPct_PROPERTIES
    },
    txtcolDelvAgreeCompId: {
      name: "txtcolDelvAgreeCompId",
      type: "TextBoxWidget",
      colName: "colDelvAgreeCompId",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDelvAgreeCompId_PROPERTIES

      // END_USER_CODE-USER_txtcolDelvAgreeCompId_PROPERTIES
    },
    txtcolDelvAgreeCropYear: {
      name: "txtcolDelvAgreeCropYear",
      type: "TextBoxWidget",
      colName: "colDelvAgreeCropYear",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDelvAgreeCropYear_PROPERTIES

      // END_USER_CODE-USER_txtcolDelvAgreeCropYear_PROPERTIES
    },
    txtcolDelvAgreeNum: {
      name: "txtcolDelvAgreeNum",
      type: "TextBoxWidget",
      colName: "colDelvAgreeNum",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDelvAgreeNum_PROPERTIES

      // END_USER_CODE-USER_txtcolDelvAgreeNum_PROPERTIES
    },
    txtcolDepositorName: {
      name: "txtcolDepositorName",
      type: "TextBoxWidget",
      colName: "colDepositorName",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDepositorName_PROPERTIES

      // END_USER_CODE-USER_txtcolDepositorName_PROPERTIES
    },
    txtcolDPSCounty: {
      name: "txtcolDPSCounty",
      type: "TextBoxWidget",
      colName: "colDPSCounty",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDPSCounty_PROPERTIES

      // END_USER_CODE-USER_txtcolDPSCounty_PROPERTIES
    },
    txtcolDPSState: {
      name: "txtcolDPSState",
      type: "TextBoxWidget",
      colName: "colDPSState",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDPSState_PROPERTIES

      // END_USER_CODE-USER_txtcolDPSState_PROPERTIES
    },
    txtcolDryChrgAmt: {
      name: "txtcolDryChrgAmt",
      type: "TextBoxWidget",
      colName: "colDryChrgAmt",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDryChrgAmt_PROPERTIES

      // END_USER_CODE-USER_txtcolDryChrgAmt_PROPERTIES
    },
    txtcolDryPerTon: {
      name: "txtcolDryPerTon",
      type: "TextBoxWidget",
      colName: "colDryPerTon",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolDryPerTon_PROPERTIES

      // END_USER_CODE-USER_txtcolDryPerTon_PROPERTIES
    },
    txtcolElectronicPaperInd: {
      name: "txtcolElectronicPaperInd",
      type: "TextBoxWidget",
      colName: "colElectronicPaperInd",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolElectronicPaperInd_PROPERTIES

      // END_USER_CODE-USER_txtcolElectronicPaperInd_PROPERTIES
    },
    txtcolElkPct: {
      name: "txtcolElkPct",
      type: "TextBoxWidget",
      colName: "colElkPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolElkPct_PROPERTIES

      // END_USER_CODE-USER_txtcolElkPct_PROPERTIES
    },
    txtcolEWRChgDateTime: {
      name: "txtcolEWRChgDateTime",
      type: "TextBoxWidget",
      colName: "colEWRChgDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolEWRChgDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolEWRChgDateTime_PROPERTIES
    },
    txtcolEWRChgUser: {
      name: "txtcolEWRChgUser",
      type: "TextBoxWidget",
      colName: "colEWRChgUser",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolEWRChgUser_PROPERTIES

      // END_USER_CODE-USER_txtcolEWRChgUser_PROPERTIES
    },
    txtcolEWRCropYear: {
      name: "txtcolEWRCropYear",
      type: "TextBoxWidget",
      colName: "colEWRCropYear",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolEWRCropYear_PROPERTIES

      // END_USER_CODE-USER_txtcolEWRCropYear_PROPERTIES
    },
    txtcolEWRRcptStatus: {
      name: "txtcolEWRRcptStatus",
      type: "TextBoxWidget",
      colName: "colEWRRcptStatus",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolEWRRcptStatus_PROPERTIES

      // END_USER_CODE-USER_txtcolEWRRcptStatus_PROPERTIES
    },
    txtcolFanPct: {
      name: "txtcolFanPct",
      type: "TextBoxWidget",
      colName: "colFanPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolFanPct_PROPERTIES

      // END_USER_CODE-USER_txtcolFanPct_PROPERTIES
    },
    txtcolFarmCounty: {
      name: "txtcolFarmCounty",
      type: "TextBoxWidget",
      colName: "colFarmCounty",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolFarmCounty_PROPERTIES

      // END_USER_CODE-USER_txtcolFarmCounty_PROPERTIES
    },
    txtcolFarmNum: {
      name: "txtcolFarmNum",
      type: "TextBoxWidget",
      colName: "colFarmNum",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolFarmNum_PROPERTIES

      // END_USER_CODE-USER_txtcolFarmNum_PROPERTIES
    },
    txtcolFarmState: {
      name: "txtcolFarmState",
      type: "TextBoxWidget",
      colName: "colFarmState",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolFarmState_PROPERTIES

      // END_USER_CODE-USER_txtcolFarmState_PROPERTIES
    },
    txtcolFlavusInd: {
      name: "txtcolFlavusInd",
      type: "TextBoxWidget",
      colName: "colFlavusInd",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolFlavusInd_PROPERTIES

      // END_USER_CODE-USER_txtcolFlavusInd_PROPERTIES
    },
    txtcolFmPct: {
      name: "txtcolFmPct",
      type: "TextBoxWidget",
      colName: "colFmPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolFmPct_PROPERTIES

      // END_USER_CODE-USER_txtcolFmPct_PROPERTIES
    },
    txtcolFrezDamPct: {
      name: "txtcolFrezDamPct",
      type: "TextBoxWidget",
      colName: "colFrezDamPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolFrezDamPct_PROPERTIES

      // END_USER_CODE-USER_txtcolFrezDamPct_PROPERTIES
    },
    txtcolGradingInd: {
      name: "txtcolGradingInd",
      type: "TextBoxWidget",
      colName: "colGradingInd",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolGradingInd_PROPERTIES

      // END_USER_CODE-USER_txtcolGradingInd_PROPERTIES
    },
    txtcolGrowerHolder: {
      name: "txtcolGrowerHolder",
      type: "TextBoxWidget",
      colName: "colGrowerHolder",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolGrowerHolder_PROPERTIES

      // END_USER_CODE-USER_txtcolGrowerHolder_PROPERTIES
    },
    txtcolHaulChrgAmt: {
      name: "txtcolHaulChrgAmt",
      type: "TextBoxWidget",
      colName: "colHaulChrgAmt",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolHaulChrgAmt_PROPERTIES

      // END_USER_CODE-USER_txtcolHaulChrgAmt_PROPERTIES
    },
    txtcolHaulPerTon: {
      name: "txtcolHaulPerTon",
      type: "TextBoxWidget",
      colName: "colHaulPerTon",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolHaulPerTon_PROPERTIES

      // END_USER_CODE-USER_txtcolHaulPerTon_PROPERTIES
    },
    txtcolHulKernPct: {
      name: "txtcolHulKernPct",
      type: "TextBoxWidget",
      colName: "colHulKernPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolHulKernPct_PROPERTIES

      // END_USER_CODE-USER_txtcolHulKernPct_PROPERTIES
    },
    txtcolHulPct: {
      name: "txtcolHulPct",
      type: "TextBoxWidget",
      colName: "colHulPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolHulPct_PROPERTIES

      // END_USER_CODE-USER_txtcolHulPct_PROPERTIES
    },
    txtcolInsuredInd: {
      name: "txtcolInsuredInd",
      type: "TextBoxWidget",
      colName: "colInsuredInd",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolInsuredInd_PROPERTIES

      // END_USER_CODE-USER_txtcolInsuredInd_PROPERTIES
    },
    txtcolIssuedDateTime: {
      name: "txtcolIssuedDateTime",
      type: "TextBoxWidget",
      colName: "colIssuedDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolIssuedDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolIssuedDateTime_PROPERTIES
    },
    txtcolIssuedUser: {
      name: "txtcolIssuedUser",
      type: "TextBoxWidget",
      colName: "colIssuedUser",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolIssuedUser_PROPERTIES

      // END_USER_CODE-USER_txtcolIssuedUser_PROPERTIES
    },
    txtcolKrsPct: {
      name: "txtcolKrsPct",
      type: "TextBoxWidget",
      colName: "colKrsPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolKrsPct_PROPERTIES

      // END_USER_CODE-USER_txtcolKrsPct_PROPERTIES
    },
    txtcolLoadinChrgRate: {
      name: "txtcolLoadinChrgRate",
      type: "TextBoxWidget",
      colName: "colLoadinChrgRate",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoadinChrgRate_PROPERTIES

      // END_USER_CODE-USER_txtcolLoadinChrgRate_PROPERTIES
    },
    txtcolLoadingRateBase: {
      name: "txtcolLoadingRateBase",
      type: "TextBoxWidget",
      colName: "colLoadingRateBase",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoadingRateBase_PROPERTIES

      // END_USER_CODE-USER_txtcolLoadingRateBase_PROPERTIES
    },
    txtcolLoadinPaidInd: {
      name: "txtcolLoadinPaidInd",
      type: "TextBoxWidget",
      colName: "colLoadinPaidInd",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoadinPaidInd_PROPERTIES

      // END_USER_CODE-USER_txtcolLoadinPaidInd_PROPERTIES
    },
    txtcolLoanable: {
      name: "txtcolLoanable",
      type: "TextBoxWidget",
      colName: "colLoanable",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanable_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanable_PROPERTIES
    },
    txtcolLoanApplicationDate: {
      name: "txtcolLoanApplicationDate",
      type: "TextBoxWidget",
      colName: "colLoanApplicationDate",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanApplicationDate_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanApplicationDate_PROPERTIES
    },
    txtcolLoanApproveDateTime: {
      name: "txtcolLoanApproveDateTime",
      type: "TextBoxWidget",
      colName: "colLoanApproveDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanApproveDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanApproveDateTime_PROPERTIES
    },
    txtcolLoanDisbursementDate: {
      name: "txtcolLoanDisbursementDate",
      type: "TextBoxWidget",
      colName: "colLoanDisbursementDate",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanDisbursementDate_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanDisbursementDate_PROPERTIES
    },
    txtcolLoanIDPType: {
      name: "txtcolLoanIDPType",
      type: "TextBoxWidget",
      colName: "colLoanIDPType",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanIDPType_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanIDPType_PROPERTIES
    },
    txtcolLoanIDPUser: {
      name: "txtcolLoanIDPUser",
      type: "TextBoxWidget",
      colName: "colLoanIDPUser",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanIDPUser_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanIDPUser_PROPERTIES
    },
    txtcolLoanNum: {
      name: "txtcolLoanNum",
      type: "TextBoxWidget",
      colName: "colLoanNum",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanNum_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanNum_PROPERTIES
    },
    txtcolLoanReceivedDate: {
      name: "txtcolLoanReceivedDate",
      type: "TextBoxWidget",
      colName: "colLoanReceivedDate",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanReceivedDate_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanReceivedDate_PROPERTIES
    },
    txtcolLoanRelDateTime: {
      name: "txtcolLoanRelDateTime",
      type: "TextBoxWidget",
      colName: "colLoanRelDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanRelDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanRelDateTime_PROPERTIES
    },
    txtcolLoanRepaymentDate: {
      name: "txtcolLoanRepaymentDate",
      type: "TextBoxWidget",
      colName: "colLoanRepaymentDate",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLoanRepaymentDate_PROPERTIES

      // END_USER_CODE-USER_txtcolLoanRepaymentDate_PROPERTIES
    },
    txtcolLotNum: {
      name: "txtcolLotNum",
      type: "TextBoxWidget",
      colName: "colLotNum",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLotNum_PROPERTIES

      // END_USER_CODE-USER_txtcolLotNum_PROPERTIES
    },
    txtcolLskLbs: {
      name: "txtcolLskLbs",
      type: "TextBoxWidget",
      colName: "colLskLbs",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLskLbs_PROPERTIES

      // END_USER_CODE-USER_txtcolLskLbs_PROPERTIES
    },
    txtcolLskTons: {
      name: "txtcolLskTons",
      type: "TextBoxWidget",
      colName: "colLskTons",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolLskTons_PROPERTIES

      // END_USER_CODE-USER_txtcolLskTons_PROPERTIES
    },
    txtcolMoistPct: {
      name: "txtcolMoistPct",
      type: "TextBoxWidget",
      colName: "colMoistPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolMoistPct_PROPERTIES

      // END_USER_CODE-USER_txtcolMoistPct_PROPERTIES
    },
    txtcolNegotInd: {
      name: "txtcolNegotInd",
      type: "TextBoxWidget",
      colName: "colNegotInd",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolNegotInd_PROPERTIES

      // END_USER_CODE-USER_txtcolNegotInd_PROPERTIES
    },
    txtcolNetLbs: {
      name: "txtcolNetLbs",
      type: "TextBoxWidget",
      colName: "colNetLbs",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolNetLbs_PROPERTIES

      // END_USER_CODE-USER_txtcolNetLbs_PROPERTIES
    },
    txtcolNetTons: {
      name: "txtcolNetTons",
      type: "TextBoxWidget",
      colName: "colNetTons",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolNetTons_PROPERTIES

      // END_USER_CODE-USER_txtcolNetTons_PROPERTIES
    },
    txtcolOkPct: {
      name: "txtcolOkPct",
      type: "TextBoxWidget",
      colName: "colOkPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolOkPct_PROPERTIES

      // END_USER_CODE-USER_txtcolOkPct_PROPERTIES
    },
    txtcolOthChrgAmt: {
      name: "txtcolOthChrgAmt",
      type: "TextBoxWidget",
      colName: "colOthChrgAmt",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolOthChrgAmt_PROPERTIES

      // END_USER_CODE-USER_txtcolOthChrgAmt_PROPERTIES
    },
    txtcolOtherPerTon: {
      name: "txtcolOtherPerTon",
      type: "TextBoxWidget",
      colName: "colOtherPerTon",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolOtherPerTon_PROPERTIES

      // END_USER_CODE-USER_txtcolOtherPerTon_PROPERTIES
    },
    txtcolPaperCntlNum: {
      name: "txtcolPaperCntlNum",
      type: "TextBoxWidget",
      colName: "colPaperCntlNum",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPaperCntlNum_PROPERTIES

      // END_USER_CODE-USER_txtcolPaperCntlNum_PROPERTIES
    },
    txtcolPaperRcptNum: {
      name: "txtcolPaperRcptNum",
      type: "TextBoxWidget",
      colName: "colPaperRcptNum",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPaperRcptNum_PROPERTIES

      // END_USER_CODE-USER_txtcolPaperRcptNum_PROPERTIES
    },
    txtcolParentWhseCity: {
      name: "txtcolParentWhseCity",
      type: "TextBoxWidget",
      colName: "colParentWhseCity",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolParentWhseCity_PROPERTIES

      // END_USER_CODE-USER_txtcolParentWhseCity_PROPERTIES
    },
    txtcolParentWhseState: {
      name: "txtcolParentWhseState",
      type: "TextBoxWidget",
      colName: "colParentWhseState",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolParentWhseState_PROPERTIES

      // END_USER_CODE-USER_txtcolParentWhseState_PROPERTIES
    },
    txtcolPayoffAmount: {
      name: "txtcolPayoffAmount",
      type: "TextBoxWidget",
      colName: "colPayoffAmount",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPayoffAmount_PROPERTIES

      // END_USER_CODE-USER_txtcolPayoffAmount_PROPERTIES
    },
    txtcolPayoffBuyPt: {
      name: "txtcolPayoffBuyPt",
      type: "TextBoxWidget",
      colName: "colPayoffBuyPt",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPayoffBuyPt_PROPERTIES

      // END_USER_CODE-USER_txtcolPayoffBuyPt_PROPERTIES
    },
    txtcolPayoffDateTime: {
      name: "txtcolPayoffDateTime",
      type: "TextBoxWidget",
      colName: "colPayoffDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPayoffDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolPayoffDateTime_PROPERTIES
    },
    txtcolPayoffRemit: {
      name: "txtcolPayoffRemit",
      type: "TextBoxWidget",
      colName: "colPayoffRemit",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPayoffRemit_PROPERTIES

      // END_USER_CODE-USER_txtcolPayoffRemit_PROPERTIES
    },
    txtcolPayoffVendor: {
      name: "txtcolPayoffVendor",
      type: "TextBoxWidget",
      colName: "colPayoffVendor",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPayoffVendor_PROPERTIES

      // END_USER_CODE-USER_txtcolPayoffVendor_PROPERTIES
    },
    txtcolPeanutTypeID: {
      name: "txtcolPeanutTypeID",
      type: "TextBoxWidget",
      colName: "colPeanutTypeID",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPeanutTypeID_PROPERTIES

      // END_USER_CODE-USER_txtcolPeanutTypeID_PROPERTIES
    },
    txtcolPrevHoldchgDateTime: {
      name: "txtcolPrevHoldchgDateTime",
      type: "TextBoxWidget",
      colName: "colPrevHoldchgDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPrevHoldchgDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolPrevHoldchgDateTime_PROPERTIES
    },
    txtcolPrevHolder: {
      name: "txtcolPrevHolder",
      type: "TextBoxWidget",
      colName: "colPrevHolder",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPrevHolder_PROPERTIES

      // END_USER_CODE-USER_txtcolPrevHolder_PROPERTIES
    },
    txtcolPrevHolderName: {
      name: "txtcolPrevHolderName",
      type: "TextBoxWidget",
      colName: "colPrevHolderName",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolPrevHolderName_PROPERTIES

      // END_USER_CODE-USER_txtcolPrevHolderName_PROPERTIES
    },
    txtcolProducerName: {
      name: "txtcolProducerName",
      type: "TextBoxWidget",
      colName: "colProducerName",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolProducerName_PROPERTIES

      // END_USER_CODE-USER_txtcolProducerName_PROPERTIES
    },
    txtcolReceiptNum: {
      name: "txtcolReceiptNum",
      type: "TextBoxWidget",
      colName: "colReceiptNum",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolReceiptNum_PROPERTIES

      // END_USER_CODE-USER_txtcolReceiptNum_PROPERTIES
    },
    txtcolReceiptValue: {
      name: "txtcolReceiptValue",
      type: "TextBoxWidget",
      colName: "colReceiptValue",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolReceiptValue_PROPERTIES

      // END_USER_CODE-USER_txtcolReceiptValue_PROPERTIES
    },
    txtcolRecordStatus: {
      name: "txtcolRecordStatus",
      type: "TextBoxWidget",
      colName: "colRecordStatus",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolRecordStatus_PROPERTIES

      // END_USER_CODE-USER_txtcolRecordStatus_PROPERTIES
    },
    txtcolRelToDateTime: {
      name: "txtcolRelToDateTime",
      type: "TextBoxWidget",
      colName: "colRelToDateTime",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolRelToDateTime_PROPERTIES

      // END_USER_CODE-USER_txtcolRelToDateTime_PROPERTIES
    },
    txtcolRelToHolder: {
      name: "txtcolRelToHolder",
      type: "TextBoxWidget",
      colName: "colRelToHolder",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolRelToHolder_PROPERTIES

      // END_USER_CODE-USER_txtcolRelToHolder_PROPERTIES
    },
    txtcolRelToWhseCode: {
      name: "txtcolRelToWhseCode",
      type: "TextBoxWidget",
      colName: "colRelToWhseCode",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolRelToWhseCode_PROPERTIES

      // END_USER_CODE-USER_txtcolRelToWhseCode_PROPERTIES
    },
    txtcolSegType: {
      name: "txtcolSegType",
      type: "TextBoxWidget",
      colName: "colSegType",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolSegType_PROPERTIES

      // END_USER_CODE-USER_txtcolSegType_PROPERTIES
    },
    txtcolSmkRsPct: {
      name: "txtcolSmkRsPct",
      type: "TextBoxWidget",
      colName: "colSmkRsPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolSmkRsPct_PROPERTIES

      // END_USER_CODE-USER_txtcolSmkRsPct_PROPERTIES
    },
    txtcolSSPct: {
      name: "txtcolSSPct",
      type: "TextBoxWidget",
      colName: "colSSPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolSSPct_PROPERTIES

      // END_USER_CODE-USER_txtcolSSPct_PROPERTIES
    },
    txtcolStorageCity: {
      name: "txtcolStorageCity",
      type: "TextBoxWidget",
      colName: "colStorageCity",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolStorageCity_PROPERTIES

      // END_USER_CODE-USER_txtcolStorageCity_PROPERTIES
    },
    txtcolStorageContainer: {
      name: "txtcolStorageContainer",
      type: "TextBoxWidget",
      colName: "colStorageContainer",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolStorageContainer_PROPERTIES

      // END_USER_CODE-USER_txtcolStorageContainer_PROPERTIES
    },
    txtcolStorageDate: {
      name: "txtcolStorageDate",
      type: "TextBoxWidget",
      colName: "colStorageDate",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolStorageDate_PROPERTIES

      // END_USER_CODE-USER_txtcolStorageDate_PROPERTIES
    },
    txtcolStorageState: {
      name: "txtcolStorageState",
      type: "TextBoxWidget",
      colName: "colStorageState",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolStorageState_PROPERTIES

      // END_USER_CODE-USER_txtcolStorageState_PROPERTIES
    },
    txtcolStorageStatus: {
      name: "txtcolStorageStatus",
      type: "TextBoxWidget",
      colName: "colStorageStatus",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolStorageStatus_PROPERTIES

      // END_USER_CODE-USER_txtcolStorageStatus_PROPERTIES
    },
    txtcolSubHolder: {
      name: "txtcolSubHolder",
      type: "TextBoxWidget",
      colName: "colSubHolder",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolSubHolder_PROPERTIES

      // END_USER_CODE-USER_txtcolSubHolder_PROPERTIES
    },
    txtcolTotalLbs: {
      name: "txtcolTotalLbs",
      type: "TextBoxWidget",
      colName: "colTotalLbs",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolTotalLbs_PROPERTIES

      // END_USER_CODE-USER_txtcolTotalLbs_PROPERTIES
    },
    txtcolTotalTons: {
      name: "txtcolTotalTons",
      type: "TextBoxWidget",
      colName: "colTotalTons",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolTotalTons_PROPERTIES

      // END_USER_CODE-USER_txtcolTotalTons_PROPERTIES
    },
    txtcolTotDamPct: {
      name: "txtcolTotDamPct",
      type: "TextBoxWidget",
      colName: "colTotDamPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolTotDamPct_PROPERTIES

      // END_USER_CODE-USER_txtcolTotDamPct_PROPERTIES
    },
    txtcolTotKernPct: {
      name: "txtcolTotKernPct",
      type: "TextBoxWidget",
      colName: "colTotKernPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolTotKernPct_PROPERTIES

      // END_USER_CODE-USER_txtcolTotKernPct_PROPERTIES
    },
    txtcolTotSmkPct: {
      name: "txtcolTotSmkPct",
      type: "TextBoxWidget",
      colName: "colTotSmkPct",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolTotSmkPct_PROPERTIES

      // END_USER_CODE-USER_txtcolTotSmkPct_PROPERTIES
    },
    txtcolTradeAccount: {
      name: "txtcolTradeAccount",
      type: "TextBoxWidget",
      colName: "colTradeAccount",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolTradeAccount_PROPERTIES

      // END_USER_CODE-USER_txtcolTradeAccount_PROPERTIES
    },
    txtcolManualIndicator: {
      name: "txtcolManualIndicator",
      type: "TextBoxWidget",
      colName: "colManualIndicator",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolManualIndicator_PROPERTIES

      // END_USER_CODE-USER_txtcolManualIndicator_PROPERTIES
    },

    txtcolManualAddUser: {
      name: "txtcolManualAddUser",
      type: "TextBoxWidget",
      colName: "colManualAddUser",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolManualAddUser_PROPERTIES

      // END_USER_CODE-USER_txtcolManualAddUser_PROPERTIES
    },

    txtcolManualAddDate: {
      name: "txtcolManualAddDate",
      type: "TextBoxWidget",
      colName: "colManualAddDate",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolManualAddDate_PROPERTIES

      // END_USER_CODE-USER_txtcolManualAddDate_PROPERTIES
    },

    txtcolMax: {
      name: "txtcolMax",
      type: "TextBoxWidget",
      colName: "colMax",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolMax_PROPERTIES

      // END_USER_CODE-USER_txtcolMax_PROPERTIES
    },
    txtcolTradeCategory: {
      name: "txtcolTradeCategory",
      type: "TextBoxWidget",
      colName: "colTradeCategory",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolTradeCategory_PROPERTIES

      // END_USER_CODE-USER_txtcolTradeCategory_PROPERTIES
    },
    txtcolUserDefined: {
      name: "txtcolUserDefined",
      type: "TextBoxWidget",
      colName: "colUserDefined",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolUserDefined_PROPERTIES

      // END_USER_CODE-USER_txtcolUserDefined_PROPERTIES
    },
    txtcolWarehouseCode: {
      name: "txtcolWarehouseCode",
      type: "TextBoxWidget",
      colName: "colWarehouseCode",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolWarehouseCode_PROPERTIES

      // END_USER_CODE-USER_txtcolWarehouseCode_PROPERTIES
    },
    txtcolWhseDepositorInd: {
      name: "txtcolWhseDepositorInd",
      type: "TextBoxWidget",
      colName: "colWhseDepositorInd",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolWhseDepositorInd_PROPERTIES

      // END_USER_CODE-USER_txtcolWhseDepositorInd_PROPERTIES
    },
    txtcolWhseLicNum: {
      name: "txtcolWhseLicNum",
      type: "TextBoxWidget",
      colName: "colWhseLicNum",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolWhseLicNum_PROPERTIES

      // END_USER_CODE-USER_txtcolWhseLicNum_PROPERTIES
    },
    txtcolWhseOperator: {
      name: "txtcolWhseOperator",
      type: "TextBoxWidget",
      colName: "colWhseOperator",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolWhseOperator_PROPERTIES

      // END_USER_CODE-USER_txtcolWhseOperator_PROPERTIES
    },
    txtcolWhseSignature: {
      name: "txtcolWhseSignature",
      type: "TextBoxWidget",
      colName: "colWhseSignature",
      parent: "gridExternalReceiptForfeitureSearchList",
      CharWidth: "48",
      Height: "",
      Width: "",
      HasLabel: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtcolWhseSignature_PROPERTIES

      // END_USER_CODE-USER_txtcolWhseSignature_PROPERTIES
    },
    txtDeliveryAgreementNum: {
      name: "txtDeliveryAgreementNum",
      type: "TextBoxWidget",
      parent: "grpbxDetails",
      Label: "Delivery Agreement #:",
      LengthRange: { MinLength: 0, MaxLength: 6 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtDeliveryAgreementNum_PROPERTIES

      // END_USER_CODE-USER_txtDeliveryAgreementNum_PROPERTIES
    },
    txtFedBuyPtNum: {
      name: "txtFedBuyPtNum",
      type: "TextBoxWidget",
      parent: "grpbxDetails",
      Label: "Fed Buy Pt #:",
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtFedBuyPtNum_PROPERTIES

      // END_USER_CODE-USER_txtFedBuyPtNum_PROPERTIES
    },
    txtReceiptNum: {
      name: "txtReceiptNum",
      type: "TextBoxWidget",
      parent: "grpbxDetails",
      Label: "Receipt #:",
      LengthRange: { MinLength: 0, MaxLength: 7 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtReceiptNum_PROPERTIES

      // END_USER_CODE-USER_txtReceiptNum_PROPERTIES
    },
    txtTotalPounds: {
      name: "txtTotalPounds",
      type: "TextBoxWidget",
      parent: "grpbxSearchList",
      Label: "Total Pounds:",
      Enabled: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtTotalPounds_PROPERTIES

      // END_USER_CODE-USER_txtTotalPounds_PROPERTIES
    },
    txtTotalReceiptValue: {
      name: "txtTotalReceiptValue",
      type: "TextBoxWidget",
      parent: "grpbxSearchList",
      Label: "Total Receipt Value:",
      Enabled: false,
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtTotalReceiptValue_PROPERTIES

      // END_USER_CODE-USER_txtTotalReceiptValue_PROPERTIES
    },
    txtWarehouseCode: {
      name: "txtWarehouseCode",
      type: "TextBoxWidget",
      parent: "grpbxDetails",
      Label: "Warehouse Code:",
      LengthRange: { MinLength: 0, MaxLength: 256 },
      ofTypeDomain: "d_String",
      // START_USER_CODE-USER_txtWarehouseCode_PROPERTIES

      // END_USER_CODE-USER_txtWarehouseCode_PROPERTIES
    },
    grpbxExternalReceiptForfeituresSearch: {
      name: "grpbxExternalReceiptForfeituresSearch",
      type: "GroupBoxWidget",
      parent: "ExternalReceiptForfeituresSearch",
      Height: "",
      Width: "",
      HasLabel: false,
      // START_USER_CODE-USER_grpbxExternalReceiptForfeituresSearch_PROPERTIES

      // END_USER_CODE-USER_grpbxExternalReceiptForfeituresSearch_PROPERTIES
    },
    cmmndCntnrActions: {
      name: "cmmndCntnrActions",
      type: "CommandContainerWidget",
      parent: "ExternalReceiptForfeituresSearch",
      Height: "",
      Width: "",
      HasLabel: false,
      // START_USER_CODE-USER_cmmndCntnrActions_PROPERTIES

      // END_USER_CODE-USER_cmmndCntnrActions_PROPERTIES
    },
  };
  let _buttonServices = {};
  let _buttonNavigation = {};
  let _winServices = {};
  const [state, setState] = useState(states);
  const thisObj = {
    context: contextType,
    state: state,
    props: props,
    _buttonServices: _buttonServices,
    _buttonNavigation: _buttonNavigation,
    _winServices: _winServices,
    setState: setState,
  };
  useEffect(() => {
    parentWindow(thisObj);
  });
  useEffect(() => {
    setTabIndex();
  },[]);
  useEffect(() => {
    callOnOpenPreSubmit(thisObj, state.windowName);
    callOnOpenService(thisObj, screenRef);
    // START_USER_CODE-USER_COMPONENTDIDMOUNT-METHODS
    formLoad();
    setEventHandlers();

    return () => {
      removeEventHandlers();
    }
    // END_USER_CODE-USER_COMPONENTDIDMOUNT-METHODS
  }, []);

  useEffect(() => {
    const externalReceiptForfeitureProfileClosed = getData(thisObj, 'ExtRctForProClose');
    if (externalReceiptForfeitureProfileClosed) {
      performSearchAndReset();
    }
  }, [gettingData]);

  thisObj.setGettingData= setGettingData;
  thisObj.gettingData = gettingData

  const [selectedRowNum, setSelectedRowNum] = useState(-1);
  const [loading, setLoading] = useState(false);
  // START_USER_CODE-USER_METHODS
  const setEventHandlers = () => {
    const txtReceiptNumbers = document.querySelectorAll('#txtReceiptNum');
    const receiptNumText = txtReceiptNumbers[txtReceiptNumbers.length - 1];
    receiptNumText.addEventListener('keypress', allowOnlyNumbers);
    setTimeout(() => {
      receiptNumText.focus();
    }, 10);
  };

  const removeEventHandlers = () => {
    const txtReceiptNumbers = document.querySelectorAll('#txtReceiptNum');
    txtReceiptNumbers[txtReceiptNumbers.length - 1].removeEventListener('keypress', allowOnlyNumbers);
  };

  function roundTo(n, digits) {
    var negative = false;
    if (digits === undefined) {
      digits = 0;
    }
    if (n < 0) {
      negative = true;
      n = n * -1;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    n = (Math.round(n) / multiplicator).toFixed(digits);
    if (negative) {
      n = (n * -1).toFixed(digits);
    }
    return n;
  };

  function formatDate(dateVal) {
    var newDate = new Date(dateVal);
    var sMonth = newDate.getMonth() + 1;
    var sDay = newDate.getDate();
    var sYear = newDate.getFullYear();
    var sHour = newDate.getHours();
    var sMinute = padValue(newDate.getMinutes());
    var sSecond = padValue(newDate.getSeconds());
    var sAMPM = "AM";

    var iHourCheck = parseInt(sHour);

    if (iHourCheck > 12) {
      sAMPM = "PM";
      sHour = iHourCheck - 12;
    }
    else if (iHourCheck === 0) {
      sHour = "12";
    }
    return sMonth + "/" + sDay + "/" + sYear + " " + sHour + ":" + sMinute + ":" + sSecond + " " + sAMPM;
  };

  function padValue(value) {
    return (value < 10) ? "0" + value : value;
  };

  const allowOnlyNumbers = (e) => {
    if (!((e.keyCode >= 48 && e.keyCode <= 57)
      || e.keyCode === 8
      || e.keyCode === 3
      || e.keyCode === 22
      || e.keyCode === 24)) {
      e.preventDefault();
    }
  };

  const performSearchAndReset = async () => {
    await DoSearch();
    setData(thisObj, 'ExtRctForProClose', false);
  };

  const fillTypeList = () => {
    try {
      const peanutTypeList = [];
      peanutTypeList.push({ key: '', description: '>>> All Types <<<' });
      peanutTypeList.push({ key: 'RUN', description: 'Runner' });
      peanutTypeList.push({ key: 'SPE', description: 'Spanish SouthEast' });
      peanutTypeList.push({ key: 'SPW', description: 'Spanish SouthWest' });
      peanutTypeList.push({ key: 'VAL', description: 'Valencia' });
      peanutTypeList.push({ key: 'VIR', description: 'Virginia' });

      thisObj.setState(current => {
        return {
          ...current,
          ddPeanutType: {
            ...state.ddPeanutType,
            valueList: peanutTypeList
          }
        }
      });
      setValue(thisObj, 'ddPeanutType', '');
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during fillTypeList: ${error?.toString()}`
        );
      }
    }
  };

  const fillStatusList = () => {
    try {
      const recordStatusList = [];
      recordStatusList.push({ key: '', description: '>>> All <<<' });
      recordStatusList.push({ key: 'LOADED', description: 'LOADED' });
      recordStatusList.push({ key: 'RELEASED', description: 'RELEASED' });

      thisObj.setState(current => {
        return {
          ...current,
          ddRecordStatus: {
            ...state.ddRecordStatus,
            valueList: recordStatusList
          }
        }
      });
      setValue(thisObj, 'ddRecordStatus', '');
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during fillStatusList: ${error?.toString()}`
        );
      }
    }
  };

  const compIdFromLS = () => (sessionStorage.getItem('compId'));
  const cropYearFromLS = () => (JSON.parse(sessionStorage.getItem('year')));
  const useridFromLS = () => (sessionStorage.getItem('userid') || '');

  const formLoad = async () => {
    try {
      const cropYear = cropYearFromLS();
      setValue(thisObj, 'lblCropYear', cropYear);

      fillStatusList();
      fillTypeList();

      const functionId = 'PN1090';
      const functionSubId = '014';
      const access = 'D';
      const permissionResponse = await ContractManagementService
        .RetrieveAccessPermissionDetails(functionId, functionSubId, access, null);
      if (permissionResponse?.length && permissionResponse[0]?.permission?.toUpperCase() === 'Y') {
        show(thisObj, 'btnCreate');
      } else {
        hide(thisObj, 'btnCreate');
      }
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during formLoad: ${error?.toString()}`
        );
      }
    }
  };

  const DoSearch = async () => {
    try {
      let temp_WRNumber = '';

      const recordStatus = getValue(thisObj, 'ddRecordStatus');
      const peanutType = getValue(thisObj, 'ddPeanutType');
      const txtWarehouseCode = getValue(thisObj, 'txtWarehouseCode');
      const txtBuyingPoint = getValue(thisObj, 'txtFedBuyPtNum');
      const txtWRNumber = getValue(thisObj, 'txtReceiptNum');
      const txtDeliveryAgreement = getValue(thisObj, 'txtDeliveryAgreementNum');

      if (["LOADED", "RELEASED"].includes(recordStatus) && txtWarehouseCode === '') {
        if (txtBuyingPoint?.toUpperCase() === ">>> ALL LOCATIONS <<<"
          && txtWRNumber?.trim() === '' && txtDeliveryAgreement?.trim() === '') {
          showMessage(thisObj, "Must enter Obligation or Record Status when not specifying Receipt #.");
          return;
        }
      }

      if (txtWRNumber?.trim() !== '') {
        temp_WRNumber = txtWRNumber?.toString()?.padStart(7, '0');
      }
      setLoading(true);
      const funcId = 'PN1090P';
      const searchResponse = await WarehouseReceiptService.RetrieveExternalReceiptList(funcId, null,
        txtWarehouseCode, temp_WRNumber, txtDeliveryAgreement, txtWRNumber, recordStatus, peanutType, txtBuyingPoint);

      setGridData(searchResponse);
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during DoSearch: ${error?.toString()}`
        );
      }
    }
  };

  const onbtnSearchClick = async () => {
    try {
      await DoSearch();
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during onbtnSearchClick: ${error?.toString()}`
        );
      }
    }
  };

  thisObj.onbtnSearchClick = onbtnSearchClick;

  const setGridData = searchResultData => {
    let dblTotalLbs = 0.00;
    let dblTotalRcptValue = 0.00;
    const gridData = [];
    try {
      if (searchResultData?.length) {
        for (let i = 0; i < searchResultData.length; i++) {
          const rowData = searchResultData[i];

          const receipt_num = rowData.receipt_num;
          const record_status = rowData.record_status + ' ';
          const total_lbs = (rowData.total_lbs && !isNaN(rowData.total_lbs) ? parseFloat(rowData.total_lbs) : '');
          const farm_state = rowData.farm_state;
          const farm_county = rowData.farm_county;
          const farm_numer = rowData.farm_numer;
          const producer_name = rowData.producer_name;
          const peanut_type_id = rowData.peanut_type_id;
          const buy_pt_number = rowData.buy_pt_number;
          const buy_pt_name = rowData.buy_pt_name;
          const receipt_value = rowData.receipt_value && !isNaN(rowData.receipt_value) ? parseFloat(rowData.receipt_value) : '';
          const ccc_whse_code = rowData.ccc_whse_code;

          dblTotalLbs = dblTotalLbs + (total_lbs && !isNaN(total_lbs) ? parseFloat(total_lbs) : 0);
          dblTotalRcptValue = dblTotalRcptValue + (receipt_value && !isNaN(receipt_value) ? parseFloat(receipt_value) : 0);

          // 'Below values will not be displayed initially, only for filling
          // 'frmExtRecieptForfeituresProfile form
          // '***************************************************

          const whse_license_num = rowData.whse_license_num;
          const negotiable_ind = rowData.negotiable_ind;
          const insured_ind = rowData.insured_ind;
          const paper_rcpt_num = rowData.paper_rcpt_num;
          const net_lbs = rowData.net_lbs;
          const net_tons = rowData.net_tons && !isNaN(rowData.net_tons)
            ? parseFloat(rowData.net_tons) : '';
          const lsk_lbs = rowData.lsk_lbs;
          const lsk_tons = rowData.lsk_tons && !isNaN(rowData.lsk_tons)
            ? parseFloat(rowData.lsk_tons) : '';
          const total_tons = rowData.total_tons && !isNaN(rowData.total_tons)
            ? parseFloat(rowData.total_tons) : '';
          const storage_date = rowData.storage_date
            ? formatDate(rowData.storage_date).split(' ')[0] : '';
          const storage_container = rowData.storage_container;
          const storage_staus = rowData.storage_staus;
          const parent_whse_city = rowData.parent_whse_city;
          const parent_whse_state = rowData.parent_whse_state;
          const depositor_name = rowData.depositor_name;
          const storage_city = rowData.storage_city;
          const storage_state = rowData.storage_state;
          const loadin_chrg_rate = rowData.loadin_chrg_rate && !isNaN(rowData.loadin_chrg_rate)
            ? parseFloat(rowData.loadin_chrg_rate) : '';
          const loadin_paid_ind = rowData.loadin_paid_ind;
          const loading_rate_base = rowData.loading_rate_base;
          const grading_ind = rowData.grading_ind;
          const seg_type = rowData.seg_type;
          const moist_pct = rowData.moist_pct && !isNaN(rowData.moist_pct)
            ? parseFloat(rowData.moist_pct) : '';
          const fm_pct = rowData.fm_pct && !isNaN(rowData.fm_pct)
            ? parseFloat(rowData.fm_pct) : '';
          const elk_pct = rowData.elk_pct && !isNaN(rowData.elk_pct)
            ? parseFloat(rowData.elk_pct) : '';

          const cr_br_pct = rowData.cr_br_pct && !isNaN(rowData.cr_br_pct)
            ? parseFloat(rowData.cr_br_pct) : '';
          const dcol_shel_pct = rowData.dcol_shel_pct && !isNaN(rowData.dcol_shel_pct)
            ? parseFloat(rowData.dcol_shel_pct) : '';
          const lot_number = rowData.lot_number;
          const krs_pct = rowData.krs_pct && !isNaN(rowData.krs_pct)
            ? parseFloat(rowData.krs_pct) : '';
          const dam_krs_pct = rowData.dam_krs_pct && !isNaN(rowData.dam_krs_pct)
            ? parseFloat(rowData.dam_krs_pct) : '';
          const smk_rs_pct = rowData.smk_rs_pct && !isNaN(rowData.smk_rs_pct)
            ? parseFloat(rowData.smk_rs_pct) : '';
          const ss_pct = rowData.ss_pct && !isNaN(rowData.ss_pct)
            ? parseFloat(rowData.ss_pct) : '';
          const tot_smk_pct = rowData.tot_smk_pct && !isNaN(rowData.tot_smk_pct)
            ? parseFloat(rowData.tot_smk_pct) : '';
          const ok_pct = rowData.ok_pct && !isNaN(rowData.ok_pct)
            ? parseFloat(rowData.ok_pct) : '';
          const dam_s_pct = rowData.dam_s_pct && !isNaN(rowData.dam_s_pct)
            ? parseFloat(rowData.dam_s_pct) : '';
          const tot_dam_pct = rowData.tot_dam_pct && !isNaN(rowData.tot_dam_pct)
            ? parseFloat(rowData.tot_dam_pct) : '';
          const tot_kern_pct = rowData.tot_kern_pct && !isNaN(rowData.tot_kern_pct)
            ? parseFloat(rowData.tot_kern_pct) : '';
          const hul_pct = rowData.hul_pct && !isNaN(rowData.hul_pct)
            ? parseFloat(rowData.hul_pct) : '';
          const flavus_ind = rowData.flavus_ind;
          const hul_kern_pct = rowData.hul_kern_pct && !isNaN(rowData.hul_kern_pct)
            ? parseFloat(rowData.hul_kern_pct) : '';
          const frez_dam_pct = rowData.frez_dam_pct && !isNaN(rowData.frez_dam_pct)
            ? parseFloat(rowData.frez_dam_pct) : '';
          const cncl_rmd_pct = rowData.cncl_rmd_pct && !isNaN(rowData.cncl_rmd_pct)
            ? parseFloat(rowData.cncl_rmd_pct) : '';
          const whse_depositor_ind = rowData.whse_depositor_ind;
          const whse_operator = rowData.whse_operator;
          const whse_signature = rowData.whse_signature;
          const paper_cntl_num = rowData.paper_cntl_num;
          const cnl_per_ton = rowData.cnl_per_ton;
          const dry_per_ton = rowData.dry_per_ton;
          const cln_dry_per_ton = rowData.cln_dry_per_ton;
          const haul_per_ton = rowData.haul_per_ton;
          const other_per_ton = rowData.other_per_ton;
          const cln_chrg_amt = rowData.cln_chrg_amt && !isNaN(rowData.cln_chrg_amt)
            ? parseFloat(rowData.cln_chrg_amt) : '';
          const dry_chrg_amt = rowData.dry_chrg_amt && !isNaN(rowData.dry_chrg_amt)
            ? parseFloat(rowData.dry_chrg_amt) : '';
          const cln_dry_chrg_amt = rowData.cln_dry_chrg_amt && !isNaN(rowData.cln_dry_chrg_amt)
            ? parseFloat(rowData.cln_dry_chrg_amt) : '';
          const haul_chrg_amt = rowData.haul_chrg_amt && !isNaN(rowData.haul_chrg_amt)
            ? parseFloat(rowData.haul_chrg_amt) : '';
          const oth_chrg_amt = rowData.oth_chrg_amt && !isNaN(rowData.oth_chrg_amt)
            ? parseFloat(rowData.oth_chrg_amt) : '';
          const dps_state = rowData.dps_state;
          const dps_county = rowData.dps_county;
          const loan_number = rowData.loan_number;
          const cur_holder = rowData.cur_holder;
          const cur_holder_date_time = rowData.cur_holder_date_time;
          const sub_holder = rowData.sub_holder;
          const prev_holder = rowData.prev_holder;
          const ewr_rcpt_status = rowData.ewr_rcpt_status;
          const electronic_paper_ind = rowData.electronic_paper_ind;
          const ccc_loan_status = rowData.ccc_loan_status;
          const issued_date_time = rowData.issued_date_time
            ? formatDate(rowData.issued_date_time).split(' ')[0] : '';
          const cancel_date_time = rowData.cancel_date_time
            ? formatDate(rowData.cancel_date_time).split(' ')[0] : '';
          const ewr_chg_date_time = rowData.ewr_chg_date_time
            ? formatDate(rowData.ewr_chg_date_time).split(' ')[0] : '';
          const loan_approve_date_time = rowData.loan_approve_date_time
            ? formatDate(rowData.loan_approve_date_time).split(' ')[0] : '';
          const loan_rel_date_time = rowData.loan_rel_date_time
            ? formatDate(rowData.loan_rel_date_time).split(' ')[0] : '';
          const issued_user = rowData.issued_user;
          const cancel_user = rowData.cancel_user;
          const ewr_chg_user = rowData.ewr_chg_user;
          const loan_ldp_user = rowData.loan_ldp_user;
          const grower_holder = rowData.grower_holder;
          const loanable = rowData.loanable;
          const loan_ldp_type = rowData.loan_ldp_type;
          const prev_hold_chg_date_time = rowData.prev_hold_chg_date_time
            ? formatDate(rowData.prev_hold_chg_date_time).split(' ')[0] : '';
          const curr_holder_name = rowData.curr_holder_name;
          const prev_holder_name = rowData.prev_holder_name;
          const loan_disbursement_date = rowData.loan_disbursement_date
            ? formatDate(rowData.loan_disbursement_date).split(' ')[0] : '';
          const loan_application_date = rowData.loan_application_date
            ? formatDate(rowData.loan_application_date).split(' ')[0] : '';
          const loan_repayment_date = rowData.loan_repayment_date
            ? formatDate(rowData.loan_repayment_date).split(' ')[0] : '';
          const loan_received_date = rowData.loan_received_date
            ? formatDate(rowData.loan_received_date).split(' ')[0] : '';
          const ccc_error_code = rowData.ccc_error_code;
          const user_defined = rowData.user_defined;
          const payoff_amount = rowData.payoff_amount;
          const payoff_vendor = rowData.payoff_vendor;
          const payoff_remit = rowData.payoff_remit;

          const payoff_date_time = rowData.payoff_date_time;
          const rel_to_holder = rowData.rel_to_holder;
          const rel_to_whse_code = rowData.rel_to_whse_code;
          const rel_to_date_time = rowData.rel_to_date_time
            ? formatDate(rowData.rel_to_date_time).split(' ')[0] : '';
          const delv_agree_comp_id = rowData.delv_agree_comp_id;
          const delv_agree_crop_year = rowData.delv_agree_crop_year;
          const delv_agree_num = rowData.delv_agree_num;
          const chg_user = rowData.chg_user;
          const chg_date_time = rowData.chg_date_time;
          const fan_pct = rowData.fan_pct && !isNaN(rowData.fan_pct)
            ? parseFloat(rowData.fan_pct) : '';
          const payoff_buy_pt = rowData.payoff_buy_pt;
          const ewr_crop_year = rowData.ewr_crop_year;
          const trade_category = rowData.trade_category;
          const trade_account = rowData.trade_account;

          // '2010-005
          const manual_ind = rowData.manual_ind;
          const manual_add_user = rowData.manual_add_user;
          const manual_add_date_time = rowData.manual_add_date_time;


          const gridRowData = {
            txtcolReceiptNum: receipt_num,
            txtcolRecordStatus: record_status,
            txtcolTotalLbs: total_lbs,
            txtcolFarmState: farm_state,
            txtcolFarmCounty: farm_county,
            txtcolFarmNum: farm_numer,
            txtcolProducerName: producer_name,
            txtcolPeanutTypeID: peanut_type_id,
            txtcolBuyingPointNum: buy_pt_number,
            txtcolBuyingPointName: buy_pt_name,
            txtcolReceiptValue: receipt_value,
            txtcolWarehouseCode: ccc_whse_code,
            txtcolWhseLicNum: whse_license_num,
            txtcolNegotInd: negotiable_ind,
            txtcolInsuredInd: insured_ind,
            txtcolPaperRcptNum: paper_rcpt_num,
            txtcolNetLbs: net_lbs,
            txtcolNetTons: net_tons,
            txtcolLskLbs: lsk_lbs,
            txtcolLskTons: lsk_tons,
            txtcolTotalTons: total_tons,
            txtcolStorageDate: storage_date,
            txtcolStorageContainer: storage_container,
            txtcolStorageStatus: storage_staus,
            txtcolParentWhseCity: parent_whse_city,
            txtcolParentWhseState: parent_whse_state,
            txtcolDepositorName: depositor_name,
            txtcolStorageCity: storage_city,
            txtcolStorageState: storage_state,
            txtcolLoadinChrgRate: loadin_chrg_rate,
            txtcolLoadinPaidInd: loadin_paid_ind,
            txtcolLoadingRateBase: loading_rate_base,
            txtcolGradingInd: grading_ind,
            txtcolSegType: seg_type,
            txtcolMoistPct: moist_pct,
            txtcolFmPct: fm_pct,
            txtcolElkPct: elk_pct,
            txtcolCrBrPct: cr_br_pct,
            txtcolDcolShelPct: dcol_shel_pct,
            txtcolLotNum: lot_number,
            txtcolKrsPct: krs_pct,
            txtcolDamKrsPct: dam_krs_pct,
            txtcolSmkRsPct: smk_rs_pct,
            txtcolSSPct: ss_pct,
            txtcolTotSmkPct: tot_smk_pct,
            txtcolOkPct: ok_pct,
            txtcolDamSPct: dam_s_pct,
            txtcolTotDamPct: tot_dam_pct,
            txtcolTotKernPct: tot_kern_pct,
            txtcolHulPct: hul_pct,
            txtcolFlavusInd: flavus_ind,
            txtcolHulKernPct: hul_kern_pct,
            txtcolFrezDamPct: frez_dam_pct,
            txtcolCnclRmdPct: cncl_rmd_pct,
            txtcolWhseDepositorInd: whse_depositor_ind,
            txtcolWhseOperator: whse_operator,
            txtcolWhseSignature: whse_signature,
            txtcolPaperCntlNum: paper_cntl_num,
            txtcolCnlPerTon: cnl_per_ton,
            txtcolDryPerTon: dry_per_ton,
            txtcolClnDryPerTon: cln_dry_per_ton,
            txtcolHaulPerTon: haul_per_ton,
            txtcolOtherPerTon: other_per_ton,
            txtcolClnChrgAmt: cln_chrg_amt,
            txtcolDryChrgAmt: dry_chrg_amt,
            txtcolClnDryChrgAmt: cln_dry_chrg_amt,
            txtcolHaulChrgAmt: haul_chrg_amt,
            txtcolOthChrgAmt: oth_chrg_amt,
            txtcolDPSState: dps_state,
            txtcolDPSCounty: dps_county,
            txtcolLoanNum: loan_number,
            txtcolCurrHolder: cur_holder,
            txtcolCurHolderDateTime: cur_holder_date_time,
            txtcolSubHolder: sub_holder,
            txtcolPrevHolder: prev_holder,
            txtcolEWRRcptStatus: ewr_rcpt_status,
            txtcolElectronicPaperInd: electronic_paper_ind,
            txtcolCCCLoanStatus: ccc_loan_status,
            txtcolIssuedDateTime: issued_date_time,
            txtcolCancelDateTime: cancel_date_time,
            txtcolEWRChgDateTime: ewr_chg_date_time,
            txtcolLoanApproveDateTime: loan_approve_date_time,
            txtcolLoanRelDateTime: loan_rel_date_time,
            txtcolIssuedUser: issued_user,
            txtcolCancelUser: cancel_user,
            txtcolEWRChgUser: ewr_chg_user,
            txtcolLoanIDPUser: loan_ldp_user,
            txtcolGrowerHolder: grower_holder,
            txtcolLoanable: loanable,
            txtcolLoanIDPType: loan_ldp_type,
            txtcolPrevHoldchgDateTime: prev_hold_chg_date_time,
            txtcolCurrHolderName: curr_holder_name,
            txtcolPrevHolderName: prev_holder_name,
            txtcolLoanDisbursementDate: loan_disbursement_date,
            txtcolLoanApplicationDate: loan_application_date,
            txtcolLoanRepaymentDate: loan_repayment_date,
            txtcolLoanReceivedDate: loan_received_date,
            txtcolCCCErrorCode: ccc_error_code,
            txtcolUserDefined: user_defined,
            txtcolPayoffAmount: payoff_amount,
            txtcolPayoffVendor: payoff_vendor,
            txtcolPayoffRemit: payoff_remit,
            txtcolPayoffDateTime: payoff_date_time,
            txtcolRelToHolder: rel_to_holder,
            txtcolRelToWhseCode: rel_to_whse_code,
            txtcolRelToDateTime: rel_to_date_time,
            txtcolDelvAgreeCompId: delv_agree_comp_id,
            txtcolDelvAgreeCropYear: delv_agree_crop_year,
            txtcolDelvAgreeNum: delv_agree_num,
            txtcolChgUser: chg_user,
            txtcolChgDateTime: chg_date_time,
            txtcolFanPct: fan_pct,
            txtcolPayoffBuyPt: payoff_buy_pt,
            txtcolEWRCropYear: ewr_crop_year,
            txtcolTradeCategory: trade_category,
            txtcolTradeAccount: trade_account,
            txtcolManualIndicator: manual_ind,
            txtcolManualAddUser: manual_add_user,
            txtcolManualAddDate: manual_add_date_time,
          };
          gridData.push(gridRowData);
        }
      }

      setValue(thisObj, gridId, gridData);
      if (gridData.length > 0) {
        setSelectedRowNum(0);
        gridData[0].isSelected = true;
      }

      setValue(thisObj, 'txtTotalPounds', dblTotalLbs ? parseFloat(roundTo(dblTotalLbs, 2)).toString() : '0');
      setValue(thisObj, 'txtTotalReceiptValue', dblTotalRcptValue ? parseFloat(roundTo(dblTotalRcptValue, 2)).toString() : '0');
      setLoading(false);
      checkForShowAllColumns();
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during setGridData: ${error?.toString()}`
        );
      }
    }
  };

  const checkForShowAllColumns = () => {
    setLoading(true);
    setTimeout(() => {
      const shouldShowAllColumns = getValue(thisObj, 'chkboxShowAllFields');
      if (shouldShowAllColumns) {
        showAllColumns();
      } else {
        hideExtraColumns();
      }
      hideColumn(thisObj, gridId, 'txtcolMax');
    }, 5);

    setTimeout(() => {
      setLoading(false);
    }, 10);
  }

  thisObj.onchkboxShowAllFieldsChange = checkForShowAllColumns;

  const selectRow = (newRowNum) => {
    const gridData = getValue(thisObj, gridId);
    if (newRowNum !== undefined && selectedRowNum !== undefined && gridData?.length) {
      gridData[selectedRowNum].isSelected = false;
      setSelectedRowNum(newRowNum);
    }
  }

  const ongridExternalReceiptForfeitureSearchListRowSelect = (rowItems) => {
    const rowNum = getSelectedRowNumber(thisObj, gridId);
    selectRow(rowNum);
  }

  thisObj.ongridExternalReceiptForfeitureSearchListRowSelect = ongridExternalReceiptForfeitureSearchListRowSelect;

  const showAllColumns = () => {
    try {
      showColumn(thisObj, gridId, 'txtcolWhseLicNum');
      showColumn(thisObj, gridId, 'txtcolNegotInd');
      showColumn(thisObj, gridId, 'txtcolInsuredInd');
      showColumn(thisObj, gridId, 'txtcolPaperRcptNum');
      showColumn(thisObj, gridId, 'txtcolNetLbs');
      showColumn(thisObj, gridId, 'txtcolNetTons');
      showColumn(thisObj, gridId, 'txtcolLskLbs');
      showColumn(thisObj, gridId, 'txtcolLskTons');
      showColumn(thisObj, gridId, 'txtcolTotalTons');
      showColumn(thisObj, gridId, 'txtcolStorageDate');
      showColumn(thisObj, gridId, 'txtcolStorageContainer');
      showColumn(thisObj, gridId, 'txtcolStorageStatus');
      showColumn(thisObj, gridId, 'txtcolParentWhseCity');
      showColumn(thisObj, gridId, 'txtcolParentWhseState');
      showColumn(thisObj, gridId, 'txtcolDepositorName');
      showColumn(thisObj, gridId, 'txtcolStorageCity');
      showColumn(thisObj, gridId, 'txtcolStorageState');
      showColumn(thisObj, gridId, 'txtcolLoadinChrgRate');
      showColumn(thisObj, gridId, 'txtcolLoadinPaidInd');
      showColumn(thisObj, gridId, 'txtcolLoadingRateBase');
      showColumn(thisObj, gridId, 'txtcolGradingInd');
      showColumn(thisObj, gridId, 'txtcolSegType');
      showColumn(thisObj, gridId, 'txtcolMoistPct');
      showColumn(thisObj, gridId, 'txtcolFmPct');
      showColumn(thisObj, gridId, 'txtcolElkPct');
      showColumn(thisObj, gridId, 'txtcolCrBrPct');
      showColumn(thisObj, gridId, 'txtcolDcolShelPct');
      showColumn(thisObj, gridId, 'txtcolLotNum');
      showColumn(thisObj, gridId, 'txtcolKrsPct');
      showColumn(thisObj, gridId, 'txtcolDamKrsPct');
      showColumn(thisObj, gridId, 'txtcolSmkRsPct');
      showColumn(thisObj, gridId, 'txtcolSSPct');
      showColumn(thisObj, gridId, 'txtcolTotSmkPct');
      showColumn(thisObj, gridId, 'txtcolOkPct');
      showColumn(thisObj, gridId, 'txtcolDamSPct');
      showColumn(thisObj, gridId, 'txtcolTotDamPct');
      showColumn(thisObj, gridId, 'txtcolTotKernPct');
      showColumn(thisObj, gridId, 'txtcolHulPct');
      showColumn(thisObj, gridId, 'txtcolFlavusInd');
      showColumn(thisObj, gridId, 'txtcolHulKernPct');
      showColumn(thisObj, gridId, 'txtcolFrezDamPct');
      showColumn(thisObj, gridId, 'txtcolCnclRmdPct');
      showColumn(thisObj, gridId, 'txtcolWhseDepositorInd');
      showColumn(thisObj, gridId, 'txtcolWhseOperator');
      showColumn(thisObj, gridId, 'txtcolWhseSignature');
      showColumn(thisObj, gridId, 'txtcolPaperCntlNum');
      showColumn(thisObj, gridId, 'txtcolCnlPerTon');
      showColumn(thisObj, gridId, 'txtcolDryPerTon');
      showColumn(thisObj, gridId, 'txtcolClnDryPerTon');
      showColumn(thisObj, gridId, 'txtcolHaulPerTon');
      showColumn(thisObj, gridId, 'txtcolOtherPerTon');
      showColumn(thisObj, gridId, 'txtcolClnChrgAmt');
      showColumn(thisObj, gridId, 'txtcolDryChrgAmt');
      showColumn(thisObj, gridId, 'txtcolClnDryChrgAmt');
      showColumn(thisObj, gridId, 'txtcolHaulChrgAmt');
      showColumn(thisObj, gridId, 'txtcolOthChrgAmt');
      showColumn(thisObj, gridId, 'txtcolDPSState');
      showColumn(thisObj, gridId, 'txtcolDPSCounty');
      showColumn(thisObj, gridId, 'txtcolLoanNum');
      showColumn(thisObj, gridId, 'txtcolCurrHolder');
      showColumn(thisObj, gridId, 'txtcolCurHolderDateTime');
      showColumn(thisObj, gridId, 'txtcolSubHolder');
      showColumn(thisObj, gridId, 'txtcolPrevHolder');
      showColumn(thisObj, gridId, 'txtcolEWRRcptStatus');
      showColumn(thisObj, gridId, 'txtcolElectronicPaperInd');
      showColumn(thisObj, gridId, 'txtcolCCCLoanStatus');
      showColumn(thisObj, gridId, 'txtcolIssuedDateTime');
      showColumn(thisObj, gridId, 'txtcolCancelDateTime');
      showColumn(thisObj, gridId, 'txtcolEWRChgDateTime');
      showColumn(thisObj, gridId, 'txtcolLoanApproveDateTime');
      showColumn(thisObj, gridId, 'txtcolLoanRelDateTime');
      showColumn(thisObj, gridId, 'txtcolIssuedUser');
      showColumn(thisObj, gridId, 'txtcolCancelUser');
      showColumn(thisObj, gridId, 'txtcolEWRChgUser');
      showColumn(thisObj, gridId, 'txtcolLoanIDPUser');
      showColumn(thisObj, gridId, 'txtcolGrowerHolder');
      showColumn(thisObj, gridId, 'txtcolLoanable');
      showColumn(thisObj, gridId, 'txtcolLoanIDPType');
      showColumn(thisObj, gridId, 'txtcolPrevHoldchgDateTime');
      showColumn(thisObj, gridId, 'txtcolCurrHolderName');
      showColumn(thisObj, gridId, 'txtcolPrevHolderName');
      showColumn(thisObj, gridId, 'txtcolLoanDisbursementDate');
      showColumn(thisObj, gridId, 'txtcolLoanApplicationDate');
      showColumn(thisObj, gridId, 'txtcolLoanRepaymentDate');
      showColumn(thisObj, gridId, 'txtcolLoanReceivedDate');
      showColumn(thisObj, gridId, 'txtcolCCCErrorCode');
      showColumn(thisObj, gridId, 'txtcolUserDefined');
      showColumn(thisObj, gridId, 'txtcolPayoffAmount');
      showColumn(thisObj, gridId, 'txtcolPayoffVendor');
      showColumn(thisObj, gridId, 'txtcolPayoffRemit');
      showColumn(thisObj, gridId, 'txtcolPayoffDateTime');
      showColumn(thisObj, gridId, 'txtcolRelToHolder');
      showColumn(thisObj, gridId, 'txtcolRelToWhseCode');
      showColumn(thisObj, gridId, 'txtcolRelToDateTime');
      showColumn(thisObj, gridId, 'txtcolDelvAgreeCompId');
      showColumn(thisObj, gridId, 'txtcolDelvAgreeCropYear');
      showColumn(thisObj, gridId, 'txtcolDelvAgreeNum');
      showColumn(thisObj, gridId, 'txtcolChgUser');
      showColumn(thisObj, gridId, 'txtcolChgDateTime');
      showColumn(thisObj, gridId, 'txtcolFanPct');
      showColumn(thisObj, gridId, 'txtcolPayoffBuyPt');
      showColumn(thisObj, gridId, 'txtcolEWRCropYear');
      showColumn(thisObj, gridId, 'txtcolTradeCategory');
      showColumn(thisObj, gridId, 'txtcolTradeAccount');
      showColumn(thisObj, gridId, 'txtcolManualIndicator');
      showColumn(thisObj, gridId, 'txtcolManualAddUser');
      showColumn(thisObj, gridId, 'txtcolManualAddDate');
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during showAllColumns: ${error?.toString()}`
        );
      }
    }
  };

  const hideExtraColumns = () => {
    try {
      hideColumn(thisObj, gridId, 'txtcolWhseLicNum');
      hideColumn(thisObj, gridId, 'txtcolNegotInd');
      hideColumn(thisObj, gridId, 'txtcolInsuredInd');
      hideColumn(thisObj, gridId, 'txtcolPaperRcptNum');
      hideColumn(thisObj, gridId, 'txtcolNetLbs');
      hideColumn(thisObj, gridId, 'txtcolNetTons');
      hideColumn(thisObj, gridId, 'txtcolLskLbs');
      hideColumn(thisObj, gridId, 'txtcolLskTons');
      hideColumn(thisObj, gridId, 'txtcolTotalTons');
      hideColumn(thisObj, gridId, 'txtcolStorageDate');
      hideColumn(thisObj, gridId, 'txtcolStorageContainer');
      hideColumn(thisObj, gridId, 'txtcolStorageStatus');
      hideColumn(thisObj, gridId, 'txtcolParentWhseCity');
      hideColumn(thisObj, gridId, 'txtcolParentWhseState');
      hideColumn(thisObj, gridId, 'txtcolDepositorName');
      hideColumn(thisObj, gridId, 'txtcolStorageCity');
      hideColumn(thisObj, gridId, 'txtcolStorageState');
      hideColumn(thisObj, gridId, 'txtcolLoadinChrgRate');
      hideColumn(thisObj, gridId, 'txtcolLoadinPaidInd');
      hideColumn(thisObj, gridId, 'txtcolLoadingRateBase');
      hideColumn(thisObj, gridId, 'txtcolGradingInd');
      hideColumn(thisObj, gridId, 'txtcolSegType');
      hideColumn(thisObj, gridId, 'txtcolMoistPct');
      hideColumn(thisObj, gridId, 'txtcolFmPct');
      hideColumn(thisObj, gridId, 'txtcolElkPct');
      hideColumn(thisObj, gridId, 'txtcolCrBrPct');
      hideColumn(thisObj, gridId, 'txtcolDcolShelPct');
      hideColumn(thisObj, gridId, 'txtcolLotNum');
      hideColumn(thisObj, gridId, 'txtcolKrsPct');
      hideColumn(thisObj, gridId, 'txtcolDamKrsPct');
      hideColumn(thisObj, gridId, 'txtcolSmkRsPct');
      hideColumn(thisObj, gridId, 'txtcolSSPct');
      hideColumn(thisObj, gridId, 'txtcolTotSmkPct');
      hideColumn(thisObj, gridId, 'txtcolOkPct');
      hideColumn(thisObj, gridId, 'txtcolDamSPct');
      hideColumn(thisObj, gridId, 'txtcolTotDamPct');
      hideColumn(thisObj, gridId, 'txtcolTotKernPct');
      hideColumn(thisObj, gridId, 'txtcolHulPct');
      hideColumn(thisObj, gridId, 'txtcolFlavusInd');
      hideColumn(thisObj, gridId, 'txtcolHulKernPct');
      hideColumn(thisObj, gridId, 'txtcolFrezDamPct');
      hideColumn(thisObj, gridId, 'txtcolCnclRmdPct');
      hideColumn(thisObj, gridId, 'txtcolWhseDepositorInd');
      hideColumn(thisObj, gridId, 'txtcolWhseOperator');
      hideColumn(thisObj, gridId, 'txtcolWhseSignature');
      hideColumn(thisObj, gridId, 'txtcolPaperCntlNum');
      hideColumn(thisObj, gridId, 'txtcolCnlPerTon');
      hideColumn(thisObj, gridId, 'txtcolDryPerTon');
      hideColumn(thisObj, gridId, 'txtcolClnDryPerTon');
      hideColumn(thisObj, gridId, 'txtcolHaulPerTon');
      hideColumn(thisObj, gridId, 'txtcolOtherPerTon');
      hideColumn(thisObj, gridId, 'txtcolClnChrgAmt');
      hideColumn(thisObj, gridId, 'txtcolDryChrgAmt');
      hideColumn(thisObj, gridId, 'txtcolClnDryChrgAmt');
      hideColumn(thisObj, gridId, 'txtcolHaulChrgAmt');
      hideColumn(thisObj, gridId, 'txtcolOthChrgAmt');
      hideColumn(thisObj, gridId, 'txtcolDPSState');
      hideColumn(thisObj, gridId, 'txtcolDPSCounty');
      hideColumn(thisObj, gridId, 'txtcolLoanNum');
      hideColumn(thisObj, gridId, 'txtcolCurrHolder');
      hideColumn(thisObj, gridId, 'txtcolCurHolderDateTime');
      hideColumn(thisObj, gridId, 'txtcolSubHolder');
      hideColumn(thisObj, gridId, 'txtcolPrevHolder');
      hideColumn(thisObj, gridId, 'txtcolEWRRcptStatus');
      hideColumn(thisObj, gridId, 'txtcolElectronicPaperInd');
      hideColumn(thisObj, gridId, 'txtcolCCCLoanStatus');
      hideColumn(thisObj, gridId, 'txtcolIssuedDateTime');
      hideColumn(thisObj, gridId, 'txtcolCancelDateTime');
      hideColumn(thisObj, gridId, 'txtcolEWRChgDateTime');
      hideColumn(thisObj, gridId, 'txtcolLoanApproveDateTime');
      hideColumn(thisObj, gridId, 'txtcolLoanRelDateTime');
      hideColumn(thisObj, gridId, 'txtcolIssuedUser');
      hideColumn(thisObj, gridId, 'txtcolCancelUser');
      hideColumn(thisObj, gridId, 'txtcolEWRChgUser');
      hideColumn(thisObj, gridId, 'txtcolLoanIDPUser');
      hideColumn(thisObj, gridId, 'txtcolGrowerHolder');
      hideColumn(thisObj, gridId, 'txtcolLoanable');
      hideColumn(thisObj, gridId, 'txtcolLoanIDPType');
      hideColumn(thisObj, gridId, 'txtcolPrevHoldchgDateTime');
      hideColumn(thisObj, gridId, 'txtcolCurrHolderName');
      hideColumn(thisObj, gridId, 'txtcolPrevHolderName');
      hideColumn(thisObj, gridId, 'txtcolLoanDisbursementDate');
      hideColumn(thisObj, gridId, 'txtcolLoanApplicationDate');
      hideColumn(thisObj, gridId, 'txtcolLoanRepaymentDate');
      hideColumn(thisObj, gridId, 'txtcolLoanReceivedDate');
      hideColumn(thisObj, gridId, 'txtcolCCCErrorCode');
      hideColumn(thisObj, gridId, 'txtcolUserDefined');
      hideColumn(thisObj, gridId, 'txtcolPayoffAmount');
      hideColumn(thisObj, gridId, 'txtcolPayoffVendor');
      hideColumn(thisObj, gridId, 'txtcolPayoffRemit');
      hideColumn(thisObj, gridId, 'txtcolPayoffDateTime');
      hideColumn(thisObj, gridId, 'txtcolRelToHolder');
      hideColumn(thisObj, gridId, 'txtcolRelToWhseCode');
      hideColumn(thisObj, gridId, 'txtcolRelToDateTime');
      hideColumn(thisObj, gridId, 'txtcolDelvAgreeCompId');
      hideColumn(thisObj, gridId, 'txtcolDelvAgreeCropYear');
      hideColumn(thisObj, gridId, 'txtcolDelvAgreeNum');
      hideColumn(thisObj, gridId, 'txtcolChgUser');
      hideColumn(thisObj, gridId, 'txtcolChgDateTime');
      hideColumn(thisObj, gridId, 'txtcolFanPct');
      hideColumn(thisObj, gridId, 'txtcolPayoffBuyPt');
      hideColumn(thisObj, gridId, 'txtcolEWRCropYear');
      hideColumn(thisObj, gridId, 'txtcolTradeCategory');
      hideColumn(thisObj, gridId, 'txtcolTradeAccount');
      hideColumn(thisObj, gridId, 'txtcolManualIndicator');
      hideColumn(thisObj, gridId, 'txtcolManualAddUser');
      hideColumn(thisObj, gridId, 'txtcolManualAddDate');
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during hideExtraColumns: ${error?.toString()}`
        );
      }
    }
  };

  const onbtnCloseClick = async () => {
    try {
      document.getElementById("WarehouseReceipts_ExternalReceiptForfeituresSearchPopUp").childNodes[0].click();
    }
    catch (err) {
      if (err instanceof EvalError)
        showMessage(thisObj, err.message);
      else
        showMessage(thisObj, 'Exception in Close button Click');
    }
  };

  thisObj.onbtnCloseClick = onbtnCloseClick;

  const onbtnPrintSearchClick = async () => {
    try {
      const dataTable = getValue(thisObj, gridId);
      if (!dataTable?.length) {
        alert("Failed to Print, please perform a valid search first");
        return;
      }

      const showAllFields = getValue(thisObj, 'chkboxShowAllFields');

      const hostPath = window.location.origin;
      const imgUrl = GetReportLogoImage(window.location.origin)
      var obj = new jsPDF('landscape', 'mm', 'a4');
      var img = new Image();
      img.src = imgUrl;

      const pdfData = [];
      for (let i = 0; i < dataTable.length; i++) {
        const rowAllData = dataTable[i];
        const rowData = [
          rowAllData.txtcolReceiptNum,
          rowAllData.txtcolRecordStatus,
          rowAllData.txtcolTotalLbs,
          rowAllData.txtcolFarmState,
          rowAllData.txtcolFarmCounty,
          rowAllData.txtcolFarmNum,
          rowAllData.txtcolProducerName,
          rowAllData.txtcolPeanutTypeID,
          rowAllData.txtcolBuyingPointNum,
          rowAllData.txtcolBuyingPointName,
          rowAllData.txtcolReceiptValue,
          rowAllData.txtcolWarehouseCode
        ];

        const rowExtraColumnData = [
          rowAllData.txtcolWhseLicNum,
          rowAllData.txtcolNegotInd,
          rowAllData.txtcolInsuredInd,
          rowAllData.txtcolPaperRcptNum,
          rowAllData.txtcolNetLbs,
          rowAllData.txtcolNetTons,
          rowAllData.txtcolLskLbs,
          rowAllData.txtcolLskTons,
          rowAllData.txtcolTotalTons,
          rowAllData.txtcolStorageDate,
          rowAllData.txtcolStorageContainer,
          rowAllData.txtcolStorageStatus,
          rowAllData.txtcolParentWhseCity,
          rowAllData.txtcolParentWhseState,
          rowAllData.txtcolDepositorName,
          rowAllData.txtcolStorageCity,
          rowAllData.txtcolStorageState,
          rowAllData.txtcolLoadinChrgRate,
          rowAllData.txtcolLoadinPaidInd,
          rowAllData.txtcolLoadingRateBase,
          rowAllData.txtcolGradingInd,
          rowAllData.txtcolSegType,
          rowAllData.txtcolMoistPct,
          rowAllData.txtcolFmPct,
          rowAllData.txtcolElkPct,
          rowAllData.txtcolCrBrPct,
          rowAllData.txtcolDcolShelPct,
          rowAllData.txtcolLotNum,
          rowAllData.txtcolKrsPct,
          rowAllData.txtcolDamKrsPct,
          rowAllData.txtcolSmkRsPct,
          rowAllData.txtcolSSPct,
          rowAllData.txtcolTotSmkPct,
          rowAllData.txtcolOkPct,
          rowAllData.txtcolDamSPct,
          rowAllData.txtcolTotDamPct,
          rowAllData.txtcolTotKernPct,
          rowAllData.txtcolHulPct,
          rowAllData.txtcolFlavusInd,
          rowAllData.txtcolHulKernPct,
          rowAllData.txtcolFrezDamPct,
          rowAllData.txtcolCnclRmdPct,
          rowAllData.txtcolWhseDepositorInd,
          rowAllData.txtcolWhseOperator,
          rowAllData.txtcolWhseSignature,
          rowAllData.txtcolPaperCntlNum,
          rowAllData.txtcolCnlPerTon,
          rowAllData.txtcolDryPerTon,
          rowAllData.txtcolClnDryPerTon,
          rowAllData.txtcolHaulPerTon,
          rowAllData.txtcolOtherPerTon,
          rowAllData.txtcolClnChrgAmt,
          rowAllData.txtcolDryChrgAmt,
          rowAllData.txtcolClnDryChrgAmt,
          rowAllData.txtcolHaulChrgAmt,
          rowAllData.txtcolOthChrgAmt,
          rowAllData.txtcolDPSState,
          rowAllData.txtcolDPSCounty,
          rowAllData.txtcolLoanNum,
          rowAllData.txtcolCurrHolder,
          rowAllData.txtcolCurHolderDateTime,
          rowAllData.txtcolSubHolder,
          rowAllData.txtcolPrevHolder,
          rowAllData.txtcolEWRRcptStatus,
          rowAllData.txtcolElectronicPaperInd,
          rowAllData.txtcolCCCLoanStatus,
          rowAllData.txtcolIssuedDateTime,
          rowAllData.txtcolCancelDateTime,
          rowAllData.txtcolEWRChgDateTime,
          rowAllData.txtcolLoanApproveDateTime,
          rowAllData.txtcolLoanRelDateTime,
          rowAllData.txtcolIssuedUser,
          rowAllData.txtcolCancelUser,
          rowAllData.txtcolEWRChgUser,
          rowAllData.txtcolLoanIDPUser,
          rowAllData.txtcolGrowerHolder,
          rowAllData.txtcolLoanable,
          rowAllData.txtcolLoanIDPType,
          rowAllData.txtcolPrevHoldchgDateTime,
          rowAllData.txtcolCurrHolderName,
          rowAllData.txtcolPrevHolderName,
          rowAllData.txtcolLoanDisbursementDate,
          rowAllData.txtcolLoanApplicationDate,
          rowAllData.txtcolLoanRepaymentDate,
          rowAllData.txtcolLoanReceivedDate,
          rowAllData.txtcolCCCErrorCode,
          rowAllData.txtcolUserDefined,
          rowAllData.txtcolPayoffAmount,
          rowAllData.txtcolPayoffVendor,
          rowAllData.txtcolPayoffRemit,
          rowAllData.txtcolPayoffDateTime,
          rowAllData.txtcolRelToHolder,
          rowAllData.txtcolRelToWhseCode,
          rowAllData.txtcolRelToDateTime,
          rowAllData.txtcolDelvAgreeCompId,
          rowAllData.txtcolDelvAgreeCropYear,
          rowAllData.txtcolDelvAgreeNum,
          rowAllData.txtcolChgUser,
          rowAllData.txtcolChgDateTime,
          rowAllData.txtcolFanPct,
          rowAllData.txtcolPayoffBuyPt,
          rowAllData.txtcolEWRCropYear,
          rowAllData.txtcolTradeCategory,
          rowAllData.txtcolTradeAccount,
          rowAllData.txtcolManualIndicator,
          rowAllData.txtcolManualAddUser,
          rowAllData.txtcolManualAddDate,
        ];

        const pdfRowData = showAllFields
          ? rowData.concat(rowExtraColumnData)
          : rowData;

        pdfData.push(pdfRowData);
      }
      // Insert empty row after table rows have been added to pdfData
      const emptyLine = showAllFields
        ? Array(119).fill('')
        : Array(12).fill('');
      pdfData.push(emptyLine);

      // Append total row after empty row
      const totalRowData = [
        '', 'Total:', getValue(thisObj, 'txtTotalPounds'), '', '', '', '', '', '', 'Total:', getValue(thisObj, 'txtTotalReceiptValue'), ''
      ];
      const extraEmptyColumns = Array(107).fill('');
      const totalRow = showAllFields
        ? totalRowData.concat(extraEmptyColumns)
        : totalRowData;

      pdfData.push(totalRow);

      const basicColumnNames = [
        thisObj.state[thisObj.state.txtcolReceiptNum.colName].Label,
        thisObj.state[thisObj.state.txtcolRecordStatus.colName].Label,
        thisObj.state[thisObj.state.txtcolTotalLbs.colName].Label,
        thisObj.state[thisObj.state.txtcolFarmState.colName].Label,
        thisObj.state[thisObj.state.txtcolFarmCounty.colName].Label,
        thisObj.state[thisObj.state.txtcolFarmNum.colName].Label,
        thisObj.state[thisObj.state.txtcolProducerName.colName].Label,
        thisObj.state[thisObj.state.txtcolPeanutTypeID.colName].Label,
        thisObj.state[thisObj.state.txtcolBuyingPointNum.colName].Label,
        thisObj.state[thisObj.state.txtcolBuyingPointName.colName].Label,
        thisObj.state[thisObj.state.txtcolReceiptValue.colName].Label,
        thisObj.state[thisObj.state.txtcolWarehouseCode.colName].Label,
      ];

      const extraColumnNames = [
        thisObj.state[thisObj.state.txtcolWhseLicNum.colName].Label,
        thisObj.state[thisObj.state.txtcolNegotInd.colName].Label,
        thisObj.state[thisObj.state.txtcolInsuredInd.colName].Label,
        thisObj.state[thisObj.state.txtcolPaperRcptNum.colName].Label,
        thisObj.state[thisObj.state.txtcolNetLbs.colName].Label,
        thisObj.state[thisObj.state.txtcolNetTons.colName].Label,
        thisObj.state[thisObj.state.txtcolLskLbs.colName].Label,
        thisObj.state[thisObj.state.txtcolLskTons.colName].Label,
        thisObj.state[thisObj.state.txtcolTotalTons.colName].Label,
        thisObj.state[thisObj.state.txtcolStorageDate.colName].Label,
        thisObj.state[thisObj.state.txtcolStorageContainer.colName].Label,
        thisObj.state[thisObj.state.txtcolStorageStatus.colName].Label,
        thisObj.state[thisObj.state.txtcolParentWhseCity.colName].Label,
        thisObj.state[thisObj.state.txtcolParentWhseState.colName].Label,
        thisObj.state[thisObj.state.txtcolDepositorName.colName].Label,
        thisObj.state[thisObj.state.txtcolStorageCity.colName].Label,
        thisObj.state[thisObj.state.txtcolStorageState.colName].Label,
        thisObj.state[thisObj.state.txtcolLoadinChrgRate.colName].Label,
        thisObj.state[thisObj.state.txtcolLoadinPaidInd.colName].Label,
        thisObj.state[thisObj.state.txtcolLoadingRateBase.colName].Label,
        thisObj.state[thisObj.state.txtcolGradingInd.colName].Label,
        thisObj.state[thisObj.state.txtcolSegType.colName].Label,
        thisObj.state[thisObj.state.txtcolMoistPct.colName].Label,
        thisObj.state[thisObj.state.txtcolFmPct.colName].Label,
        thisObj.state[thisObj.state.txtcolElkPct.colName].Label,
        thisObj.state[thisObj.state.txtcolCrBrPct.colName].Label,
        thisObj.state[thisObj.state.txtcolDcolShelPct.colName].Label,
        thisObj.state[thisObj.state.txtcolLotNum.colName].Label,
        thisObj.state[thisObj.state.txtcolKrsPct.colName].Label,
        thisObj.state[thisObj.state.txtcolDamKrsPct.colName].Label,
        thisObj.state[thisObj.state.txtcolSmkRsPct.colName].Label,
        thisObj.state[thisObj.state.txtcolSSPct.colName].Label,
        thisObj.state[thisObj.state.txtcolTotSmkPct.colName].Label,
        thisObj.state[thisObj.state.txtcolOkPct.colName].Label,
        thisObj.state[thisObj.state.txtcolDamSPct.colName].Label,
        thisObj.state[thisObj.state.txtcolTotDamPct.colName].Label,
        thisObj.state[thisObj.state.txtcolTotKernPct.colName].Label,
        thisObj.state[thisObj.state.txtcolHulPct.colName].Label,
        thisObj.state[thisObj.state.txtcolFlavusInd.colName].Label,
        thisObj.state[thisObj.state.txtcolHulKernPct.colName].Label,
        thisObj.state[thisObj.state.txtcolFrezDamPct.colName].Label,
        thisObj.state[thisObj.state.txtcolCnclRmdPct.colName].Label,
        thisObj.state[thisObj.state.txtcolWhseDepositorInd.colName].Label,
        thisObj.state[thisObj.state.txtcolWhseOperator.colName].Label,
        thisObj.state[thisObj.state.txtcolWhseSignature.colName].Label,
        thisObj.state[thisObj.state.txtcolPaperCntlNum.colName].Label,
        thisObj.state[thisObj.state.txtcolCnlPerTon.colName].Label,
        thisObj.state[thisObj.state.txtcolDryPerTon.colName].Label,
        thisObj.state[thisObj.state.txtcolClnDryPerTon.colName].Label,
        thisObj.state[thisObj.state.txtcolHaulPerTon.colName].Label,
        thisObj.state[thisObj.state.txtcolOtherPerTon.colName].Label,
        thisObj.state[thisObj.state.txtcolClnChrgAmt.colName].Label,
        thisObj.state[thisObj.state.txtcolDryChrgAmt.colName].Label,
        thisObj.state[thisObj.state.txtcolClnDryChrgAmt.colName].Label,
        thisObj.state[thisObj.state.txtcolHaulChrgAmt.colName].Label,
        thisObj.state[thisObj.state.txtcolOthChrgAmt.colName].Label,
        thisObj.state[thisObj.state.txtcolDPSState.colName].Label,
        thisObj.state[thisObj.state.txtcolDPSCounty.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanNum.colName].Label,
        thisObj.state[thisObj.state.txtcolCurrHolder.colName].Label,
        thisObj.state[thisObj.state.txtcolCurHolderDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolSubHolder.colName].Label,
        thisObj.state[thisObj.state.txtcolPrevHolder.colName].Label,
        thisObj.state[thisObj.state.txtcolEWRRcptStatus.colName].Label,
        thisObj.state[thisObj.state.txtcolElectronicPaperInd.colName].Label,
        thisObj.state[thisObj.state.txtcolCCCLoanStatus.colName].Label,
        thisObj.state[thisObj.state.txtcolIssuedDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolCancelDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolEWRChgDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanApproveDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanRelDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolIssuedUser.colName].Label,
        thisObj.state[thisObj.state.txtcolCancelUser.colName].Label,
        thisObj.state[thisObj.state.txtcolEWRChgUser.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanIDPUser.colName].Label,
        thisObj.state[thisObj.state.txtcolGrowerHolder.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanable.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanIDPType.colName].Label,
        thisObj.state[thisObj.state.txtcolPrevHoldchgDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolCurrHolderName.colName].Label,
        thisObj.state[thisObj.state.txtcolPrevHolderName.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanDisbursementDate.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanApplicationDate.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanRepaymentDate.colName].Label,
        thisObj.state[thisObj.state.txtcolLoanReceivedDate.colName].Label,
        thisObj.state[thisObj.state.txtcolCCCErrorCode.colName].Label,
        thisObj.state[thisObj.state.txtcolUserDefined.colName].Label,
        thisObj.state[thisObj.state.txtcolPayoffAmount.colName].Label,
        thisObj.state[thisObj.state.txtcolPayoffVendor.colName].Label,
        thisObj.state[thisObj.state.txtcolPayoffRemit.colName].Label,
        thisObj.state[thisObj.state.txtcolPayoffDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolRelToHolder.colName].Label,
        thisObj.state[thisObj.state.txtcolRelToWhseCode.colName].Label,
        thisObj.state[thisObj.state.txtcolRelToDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolDelvAgreeCompId.colName].Label,
        thisObj.state[thisObj.state.txtcolDelvAgreeCropYear.colName].Label,
        thisObj.state[thisObj.state.txtcolDelvAgreeNum.colName].Label,
        thisObj.state[thisObj.state.txtcolChgUser.colName].Label,
        thisObj.state[thisObj.state.txtcolChgDateTime.colName].Label,
        thisObj.state[thisObj.state.txtcolFanPct.colName].Label,
        thisObj.state[thisObj.state.txtcolPayoffBuyPt.colName].Label,
        thisObj.state[thisObj.state.txtcolEWRCropYear.colName].Label,
        thisObj.state[thisObj.state.txtcolTradeCategory.colName].Label,
        thisObj.state[thisObj.state.txtcolTradeAccount.colName].Label,
        thisObj.state[thisObj.state.txtcolManualIndicator.colName].Label,
        thisObj.state[thisObj.state.txtcolManualAddUser.colName].Label,
        thisObj.state[thisObj.state.txtcolManualAddDate.colName].Label
      ];

      const allColumnNames = showAllFields
        ? basicColumnNames.concat(extraColumnNames)
        : basicColumnNames;

      const columnAlignStyle = {
        0: { halign: 'center' },
        1: { halign: 'center' },
        2: { halign: 'center' },
        4: { halign: 'center' },
        5: { halign: 'center' },
        6: { halign: 'center' },
        7: { halign: 'center' },
        8: { halign: 'center' },
        9: { halign: 'center' },
        10: { halign: 'center' },
        11: { halign: 'center' }
      };

      if (showAllFields) {
        columnAlignStyle[12] = { halign: 'right' };
        columnAlignStyle[15] = { halign: 'right' };
        columnAlignStyle[16] = { halign: 'right' };
        columnAlignStyle[17] = { halign: 'right' };
        columnAlignStyle[18] = { halign: 'right' };
        columnAlignStyle[19] = { halign: 'right' };
        columnAlignStyle[20] = { halign: 'right' };
        columnAlignStyle[29] = { halign: 'right' };
        columnAlignStyle[31] = { halign: 'right' };
        columnAlignStyle[33] = { halign: 'right' };
        columnAlignStyle[34] = { halign: 'right' };
        columnAlignStyle[35] = { halign: 'right' };
        columnAlignStyle[36] = { halign: 'right' };
        columnAlignStyle[37] = { halign: 'right' };
        columnAlignStyle[38] = { halign: 'right' };
        columnAlignStyle[39] = { halign: 'right' };
        columnAlignStyle[40] = { halign: 'right' };
        columnAlignStyle[41] = { halign: 'right' };
        columnAlignStyle[42] = { halign: 'right' };
        columnAlignStyle[43] = { halign: 'right' };
        columnAlignStyle[44] = { halign: 'right' };
        columnAlignStyle[45] = { halign: 'right' };
        columnAlignStyle[46] = { halign: 'right' };
        columnAlignStyle[47] = { halign: 'right' };
        columnAlignStyle[48] = { halign: 'right' };
        columnAlignStyle[49] = { halign: 'right' };
        columnAlignStyle[51] = { halign: 'right' };
        columnAlignStyle[52] = { halign: 'right' };
        columnAlignStyle[53] = { halign: 'right' };
        columnAlignStyle[57] = { halign: 'right' };
        columnAlignStyle[58] = { halign: 'right' };
        columnAlignStyle[59] = { halign: 'right' };
        columnAlignStyle[60] = { halign: 'right' };
        columnAlignStyle[61] = { halign: 'right' };
        columnAlignStyle[62] = { halign: 'right' };
        columnAlignStyle[63] = { halign: 'right' };
        columnAlignStyle[64] = { halign: 'right' };
        columnAlignStyle[65] = { halign: 'right' };
        columnAlignStyle[66] = { halign: 'right' };
        columnAlignStyle[67] = { halign: 'right' };
        columnAlignStyle[70] = { halign: 'right' };
        columnAlignStyle[99] = { halign: 'right' };
        columnAlignStyle[100] = { halign: 'right' };
        columnAlignStyle[101] = { halign: 'right' };
        columnAlignStyle[104] = { halign: 'right' };
        columnAlignStyle[107] = { halign: 'right' };
        columnAlignStyle[108] = { halign: 'right' };
        columnAlignStyle[111] = { halign: 'right' };
        columnAlignStyle[113] = { halign: 'right' };
        columnAlignStyle[115] = { halign: 'right' };
      }

      obj.autoTable({
        startX: 8,
        startY: 10,
        horizontalPageBreak: true,
        theme: 'plain',
        margin: { top: 8, left: 8, right: 8 },
        styles: {
          fontSize: 6.2,
          lineWidth: 0.2,
          theme: 'striped',
          halign: 'left',
          minCellWidth: 5,
          cellPadding: { top: 1, left: 2, right: 2, bottom: 0 }
        },
        columnStyles: columnAlignStyle,
        headStyles: { halign: 'center' },
        head: [allColumnNames],
        body: pdfData
      });

      var pageCount = obj.internal.getNumberOfPages();
      for (let w = 1; w <= pageCount; w++) {
        obj.setPage(w);
        obj.setFontSize(10);
        obj.text(`${cropYearFromLS()}  EXTERNAL RECEIPT FORFEITURES SEARCH GRID`, 10, 202);
        if (showAllFields) {
          obj.text(String(w), 280, 202);
        }
      }
      let fileName = prompt("Please enter the file name :");
      if (fileName != null && fileName != undefined) {
        if (fileName != '') {
          obj.save(fileName + '.pdf')
        }
        else {
          alert("Failed to print, please provide proper name to file");
        }
      }
      else {
        alert("Failed to print, please provide proper name to file");
      }
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during onbtnPrintSearchClick: ${error?.toString()}`
        );
      }
    }
  };

  thisObj.onbtnPrintSearchClick = onbtnPrintSearchClick;

  const onbtnCreateClick = () => {
    try {
      setData(thisObj,"colorKey","Red")
      const buyingPointListFromWHInquiry = getData(thisObj, 'cboBuyingPoint');
      const ExtReceiptForfeitureProfileData = {
        cmbBuyPtIdValueList: buyingPointListFromWHInquiry,
        Manual: true,
        Create: true,
      }

      setData(thisObj, 'ExtReceiptForfeitureProfileData', ExtReceiptForfeitureProfileData);

      goTo(thisObj, "WarehouseReceipts#ExtReceiptForfeituresProfile#DEFAULT#true#Click");
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during onbtnCreateClick: ${error?.toString()}`
        );
      }
    }
  };

  thisObj.onbtnCreateClick = onbtnCreateClick;

  const onbtnOpenClick = () => {
    try {
      setData(thisObj,"colorKey","black")
      const dataTable = getValue(thisObj, gridId);
      if (dataTable?.length) {
        fillExtRectForfProfile();
      }
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during onbtnOpenClick: ${error?.toString()}`
        );
      }
    }
  };

  thisObj.onbtnOpenClick = onbtnOpenClick;

  const fillExtRectForfProfile = async () => {
    try {
      const dataTable = getValue(thisObj, gridId);
      const manualInd = getGridValue(thisObj, gridId, 'txtcolManualIndicator', dataTable.length - 1); // 116
      const Manual = manualInd.trim().toUpperCase() === 'Y';

      const ewrRcptStatus = getGridValue(thisObj, gridId, 'txtcolEWRRcptStatus', selectedRowNum); // 75
      const lblExtrRcptStatus = ewrRcptStatus;

      const recordStatus = getGridValue(thisObj, gridId, 'txtcolRecordStatus', selectedRowNum); // 1
      const lblRcptStatus = recordStatus;

      const totalPounds = getGridValue(thisObj, gridId, 'txtcolTotalLbs', selectedRowNum); // 2
      const lblTotalPounds = totalPounds;
      const paperRcptNum = getGridValue(thisObj, gridId, 'txtcolPaperRcptNum', selectedRowNum); // 15
      const lblWRNum = paperRcptNum;
      const receiptNum = getGridValue(thisObj, gridId, 'txtcolReceiptNum', selectedRowNum); // 0
      const lblERcptNum = receiptNum;
      const paperCntlNum = getGridValue(thisObj, gridId, 'txtcolPaperCntlNum', selectedRowNum); // 57
      const lblControlNumber = paperCntlNum;

      const issuedDateTime = getGridValue(thisObj, gridId, 'txtcolIssuedDateTime', selectedRowNum); // 78
      const lblIssueDate = issuedDateTime; // MM/DD/YYYY

      const storageDate = getGridValue(thisObj, gridId, 'txtcolStorageDate', selectedRowNum); // 21
      const lblStorageDate = storageDate;

      const whseLicenceNum = getGridValue(thisObj, gridId, 'txtcolWhseLicNum', selectedRowNum); // 12
      const lblLicenseNumber = whseLicenceNum;

      const peanutTypeId = getGridValue(thisObj, gridId, 'txtcolPeanutTypeID', selectedRowNum); // 7
      const lblPeanutType = peanutTypeId;

      const receiptValue = getGridValue(thisObj, gridId, 'txtcolReceiptValue', selectedRowNum); // 10
      const lblOriginalRcptValue = receiptValue;

      const storageContainer = getGridValue(thisObj, gridId, 'txtcolStorageContainer', selectedRowNum); // 22
      const lblHowStored = storageContainer.trim().toUpperCase() === 'K' ? 0 : 1;

      const electronicPaperInd = getGridValue(thisObj, gridId, 'txtcolElectronicPaperInd', selectedRowNum); // 76
      const radioElectronicPaper = electronicPaperInd ? '1' : '2';

      const cancelDateTime = getGridValue(thisObj, gridId, 'txtcolCancelDateTime', selectedRowNum); // 79
      const lblDateCancelled = cancelDateTime; // MM/DD/YYYY

      const storageStatus = getGridValue(thisObj, gridId, 'txtcolStorageStatus', selectedRowNum); // 23
      const lblStatus = storageStatus.trim().toUpperCase() === 'U' ? 0 : 1;

      const warehouseCode = getGridValue(thisObj, gridId, 'txtcolWarehouseCode', selectedRowNum); // 23
      const lblCCCCode = warehouseCode;

      const segType = getGridValue(thisObj, gridId, 'txtcolSegType', selectedRowNum); // 23
      const lblSeg = segType;

      const netLbs = getGridValue(thisObj, gridId, 'txtcolNetLbs', selectedRowNum); // 16
      const lblNetPounds = netLbs;

      const totalTons = getGridValue(thisObj, gridId, 'txtcolTotalTons', selectedRowNum); // 20
      const lblTotalTons = totalTons;

      const lskLbs = getGridValue(thisObj, gridId, 'txtcolLskLbs', selectedRowNum); // 18
      const lblLSKPounds = lskLbs;

      const smkRsPct = getGridValue(thisObj, gridId, 'txtcolSmkRsPct', selectedRowNum); // 42
      const lblSMK = smkRsPct;

      const ssPct = getGridValue(thisObj, gridId, 'txtcolSSPct', selectedRowNum); // 43
      const lblSS = ssPct;

      const totSmkPct = getGridValue(thisObj, gridId, 'txtcolTotSmkPct', selectedRowNum); // 44
      const lblTotalSMk = totSmkPct;

      const okPct = getGridValue(thisObj, gridId, 'txtcolOkPct', selectedRowNum); // 45
      const lblOK = okPct;

      const totDamPct = getGridValue(thisObj, gridId, 'txtcolTotDamPct', selectedRowNum); // 47
      const lblDAM = totDamPct;

      const totKernPct = getGridValue(thisObj, gridId, 'txtcolTotKernPct', selectedRowNum); // 48
      const lblTotalKernels = totKernPct;

      const hulPct = getGridValue(thisObj, gridId, 'txtcolHulPct', selectedRowNum); // 49
      const lblHULLS = hulPct;

      const hulKernPct = getGridValue(thisObj, gridId, 'txtcolHulKernPct', selectedRowNum); // 51
      const lblTotalKernelsHulls = hulKernPct;

      const fmPct = getGridValue(thisObj, gridId, 'txtcolFmPct', selectedRowNum); // 35
      const lblFM = fmPct;

      const moistPct = getGridValue(thisObj, gridId, 'txtcolMoistPct', selectedRowNum); // 34
      const lblMOIST = moistPct;

      const elkPct = getGridValue(thisObj, gridId, 'txtcolElkPct', selectedRowNum); // 36
      const lblELK = elkPct;

      const cnclRmdPct = getGridValue(thisObj, gridId, 'txtcolCnclRmdPct', selectedRowNum); // 53
      const lblCNCLRMD = cnclRmdPct;

      const frezDamPct = getGridValue(thisObj, gridId, 'txtcolFrezDamPct', selectedRowNum); // 52
      const lblFreeze = frezDamPct;

      const crBrPct = getGridValue(thisObj, gridId, 'txtcolCrBrPct', selectedRowNum); // 37
      const lblCRBR = crBrPct;

      const chgUser = getGridValue(thisObj, gridId, 'txtcolChgUser', selectedRowNum); // 109
      const lblChangedBy = chgUser;

      const chgDateTime = getGridValue(thisObj, gridId, 'txtcolChgDateTime', selectedRowNum); // 110
      const lblAddedBy = chgDateTime;

      const fanPct = getGridValue(thisObj, gridId, 'txtcolFanPct', selectedRowNum); // 111
      const lblFancy = fanPct;

      const currHolder = getGridValue(thisObj, gridId, 'txtcolCurrHolder', selectedRowNum); // 71
      const txtCurrentHolder = currHolder;

      const currHolderName = getGridValue(thisObj, gridId, 'txtcolCurrHolderName', selectedRowNum); // 91
      const txtCurrentHolderName = currHolderName;

      const flavusInd = getGridValue(thisObj, gridId, 'txtcolFlavusInd', selectedRowNum); // 50
      const lblAFlavus = flavusInd === 'Y' ? 0 : 1;

      const loanApplicationDate = getGridValue(thisObj, gridId, 'txtcolLoanApplicationDate', selectedRowNum); // 94
      const txtCCCBeginDate = loanApplicationDate; // MM/DD/YYYY

      const loanRepaymentDate = getGridValue(thisObj, gridId, 'txtcolLoanRepaymentDate', selectedRowNum); // 95
      const txtEndDate = loanRepaymentDate; // MM/DD/YYYY

      const payoffVendor = getGridValue(thisObj, gridId, 'txtcolPayoffVendor', selectedRowNum); // 100
      const txtPayoffVendor = payoffVendor;

      const payoffAmount = getGridValue(thisObj, gridId, 'txtcolPayoffAmount', selectedRowNum); // 99
      const txtPayoffAmount = payoffAmount;

      const payoffRemit = getGridValue(thisObj, gridId, 'txtcolPayoffRemit', selectedRowNum); // 101
      const txtPayoffRemit = payoffRemit;

      const loanNum = getGridValue(thisObj, gridId, 'txtcolLoanNum', selectedRowNum); // 70
      const txtLnstate = loanNum?.toString().substring(0, 2);
      const txtLnCounty = loanNum?.toString().substring(2, 5);
      const txtLnNumber = loanNum?.toString().substring(5);

      const loanDisbursementDate = getGridValue(thisObj, gridId, 'txtcolLoanDisbursementDate', selectedRowNum); // 93
      const txtLoandate = loanDisbursementDate; // MM/DD/YYYY

      const payoffBuyPt = getGridValue(thisObj, gridId, 'txtcolPayoffBuyPt', selectedRowNum); // 112
      const cmbBuyPtId = payoffBuyPt;

      const buyingPointListFromWHInquiry = getData(thisObj, 'cboBuyingPoint');

      const hasFilledEWRCropYear = await GetExtRecpt();
      let ewrCropYear;
      if (!hasFilledEWRCropYear) {
        ewrCropYear = getGridValue(thisObj, gridId, 'txtcolEWRCropYear', selectedRowNum); // 113
      } else {
        ewrCropYear = getData(thisObj, 'lblEWRCropYear');
        setData(thisObj, 'lblEWRCropYear', null);
      }

      const tradeCategory = getGridValue(thisObj, gridId, 'txtcolTradeCategory', selectedRowNum); // 114

      const ExtReceiptForfeitureOpenData = {
        bFillRemitToList: true,
        bFillBuyPt: true,
        Create: false,
        Manual: Manual,
        EnableControls: true,
        lblExtrRcptStatus,
        lblRcptStatus,
        lblTotalPounds,
        lblWRNum,
        lblERcptNum,
        lblControlNumber,
        lblIssueDate,
        lblStorageDate,
        lblLicenseNumber,
        lblPeanutType,
        lblOriginalRcptValue,
        lblHowStored,
        radioElectronicPaper,
        lblDateCancelled,
        lblStatus,
        lblCCCCode,
        lblSeg,
        lblNetPounds,
        lblTotalTons,
        lblLSKPounds,
        lblSMK,
        lblSS,
        lblTotalSMk,
        lblOK,
        lblDAM,
        lblTotalKernels,
        lblHULLS,
        lblTotalKernelsHulls,
        lblFM,
        lblMOIST,
        lblELK,
        lblCNCLRMD,
        lblFreeze,
        lblCRBR,
        lblChangedBy,
        lblAddedBy,
        lblFancy,
        txtCurrentHolder,
        txtCurrentHolderName,
        lblAFlavus,
        txtCCCBeginDate,
        txtEndDate,
        txtPayoffVendor,
        txtPayoffAmount,
        txtPayoffRemit,
        txtLnstate,
        txtLnCounty,
        txtLnNumber,
        txtLoandate,
        cmbBuyPtId,
        cmbBuyPtIdValueList: buyingPointListFromWHInquiry,
        lblEWRCropYear: ewrCropYear,
        FillTradeCategories: tradeCategory,
      };

      setData(thisObj, 'ExtReceiptForfeitureProfileData', ExtReceiptForfeitureOpenData);
      goTo(thisObj, "WarehouseReceipts#ExtReceiptForfeituresProfile#DEFAULT#true#Click");
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during fillExtRectForfProfile: ${error?.toString()}`
        );
      }
    }
  }

  async function fillLocationList(locationCombobox) {
    try {
      const locationList = [];
      locationList.push({ key: "", description: ">>> All Locations <<<" });
      const func_id = 'PN1090P';
      const func_sub_id = '';
      const locationResponse = await WarehouseReceiptService.RetrieveExternalReceiptList(func_id, func_sub_id);
      if (locationResponse?.length) {
        for (let i = 0; i < locationResponse.length; i++) {
          const responseItem = locationResponse[i];
          if (responseItem?.buy_pt_number) {
            locationList.push({
              key: responseItem.buy_pt_number,
              description: responseItem.buy_pt_number + ' - ' + responseItem.buy_pt_name.toString()
            });
          }
        }
      }

      thisObj.setState(current => {
        return {
          ...current,
          [locationCombobox.Name]: {
            ...state[locationCombobox.Name],
            valueList: locationList
          }
        }
      });

      if (locationList.length > 1) {
        setValue(thisObj, locationCombobox.Name, locationList[0].key);
      }
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during fillLocationList: ${error?.toString()}`
        );
      }
    }
  }

  async function fillOrgLocationList(locationCombobox) {
    try {
      let LstrHold;
      const locationList = [];

      locationList.push({
        key: "",
        description: ">>> All Locations <<<"
      });

      let func_id = 'PN1090P';
      const locationResponse = WarehouseReceiptService.RetrieveExternalReceiptList(func_id);
      LstrHold = locationResponse;
      if (locationResponse?.length) {
        for (let i = 0; i < locationResponse.length; i++) {
          const responseItem = locationResponse[i];
          if (responseItem?.buy_pt_name) {
            locationList.push({
              key: responseItem.buy_pt_name,
              description: responseItem.buy_pt_name + ' - ' + responseItem.buy_pt_name.toString()
            });
          }
        }
      }

      thisObj.setState(current => {
        return {
          ...current,
          [locationCombobox.Name]: {
            ...state[locationCombobox.Name],
            valueList: locationList
          }
        }
      });

      if (locationList.length > 1) {
        setValue(thisObj, locationCombobox.Name, locationList[0].key);
      }

      func_id = 'PN1090P';
      const func_sub_id = '008';
      const locationResponse006 = await WarehouseReceiptService.RetrieveExternalReceiptList(func_id, func_sub_id);

      if (locationResponse006?.length) {
        for (let i = 0; i < locationResponse006.length; i++) {
          const responseItem = locationResponse006[i];
          if (responseItem?.buy_pt_number) {
            if (!LstrHold.some(prevList => prevList.buy_pt_number === responseItem.buy_pt_number)) {
              locationList.push({
                key: responseItem.buy_pt_number,
                description: responseItem.buy_pt_number + " - " + responseItem.buy_pt_name.toString()
              });
            }
          }
        }
      }
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during fillOrgLocationList: ${error?.toString()}`
        );
      }
    }
  }

  async function fillWarehouseCode() {
    try {
      const warehouseCodesList = [];
      const func_id = 'PN1090P';
      const func_sub_id = '008';

      const warehouseResponse = await WarehouseReceiptService.RetrieveExternalReceiptList(func_id, func_sub_id);

      if (warehouseResponse?.length) {
        for (let i = 0; i < warehouseResponse.length; i++) {
          const responseItem = warehouseResponse[i];
          if (responseItem?.ccc_whse_code) {
            warehouseCodesList.push(responseItem.ccc_whse_code);
          }
        }
      }

      if (getValue(thisObj, 'txtWarehouseCode')?.length > 0) {
        setValue(thisObj, 'txtWarehouseCode', '0');
      }
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during fillWarehouseCode: ${error?.toString()}`
        );
      }
    }
  }

  async function GetExtRecpt() {
    try {
      const func_id = 'PN1090P';
      const func_sub_id = '';
      const receiptNum = selectedRowNum !== undefined ? getGridValue(thisObj, gridId, 'txtcolReceiptNum', selectedRowNum) : '';
      const cccWarehouseCode = selectedRowNum !== undefined ? getGridValue(thisObj, gridId, 'txtcolWarehouseCode', selectedRowNum) : '';
      const extRecptResponse = await WarehouseReceiptService.RetrieveExternalReceiptDetails(func_id,
        func_sub_id, cccWarehouseCode, receiptNum);
      if (extRecptResponse.length !== 0 && extRecptResponse[0].receipt_num) {
        setData(thisObj, 'lblEWRCropYear', extRecptResponse[0]?.ewr_crop_year);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      if (error instanceof EvalError) {
        showMessage(thisObj, error?.message);
      } else {
        showMessage(
          thisObj,
          `Error occurred during GetExtRecpt: ${error?.toString()}`
        );
      }
      return false;
    }
  }

  function errorHandler(err) {
    setLoading(false);
    showMessage(thisObj, err instanceof EvalError ? err.message : 'Something went wrong. Please try again.')
  }

  const setTabIndex = () => {
    let elements = [
      'txtReceiptNum',
      'ddRecordStatus',
      'txtWarehouseCode',
      'ddPeanutType',
      'txtDeliveryAgreementNum',
      'btnSearch',
      'chkboxShowAllFields',
      'btnOpen',
      'btnClose',
      'btnPrintSearch',
      'btnCreate',
      'txtFedBuyPtNum'
    ]
    elements.map((element, index) => {
      let tabElement = document.querySelectorAll(".modal")[0].querySelector(`#${element}`);
      if(tabElement){
        tabElement.tabIndex = index + 1;
      }
    })
  }
  // END_USER_CODE-USER_METHODS
  initForm(thisObj);
  let validationSchema = object(_kaledo.validationSchema);
  let initialValues = _kaledo.initialValues;
  return (
    <Formik validationSchema={validationSchema} initialValues={initialValues}>
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
        setFieldValue,
      }) => {
        thisObj.setFieldValue = setFieldValue = setFieldValue;
        thisObj.values = values = values;
        thisObj.handleChange = handleChange = handleChange;
        thisObj.handleBlur = handleBlur = handleBlur;
        thisObj.isValid = isValid = isValid;
        thisObj.errors = errors = errors;
        return (
          <div
            className={
              _kaledo.guiModuleName + "-" + state.windowName + " col-lg-12" + " centerWidth"
            }
            data-testid={state.windowName}
            ref={screenRef}
          >
            <Modal
              show={state.showPopup}
              onHide={vlaues => {
                handleModalHide(thisObj, values);
              }}
              data={dataCopyObj.dataToCopy}
              component={state.popupComponent}
              thisObj = {thisObj}
            />
            <Loading loading={loading}></Loading>
            {/* START_USER_CODE-USER_BEFORE_PAGE_HEADER*/}
            <ContractManagement_header headerData={state.headerData} />
            {/* END_USER_CODE-USER_BEFORE_PAGE_HEADER*/}
            <h1 className="pageHeader">{state.Label}</h1>
            {/* START_USER_CODE-USER_AFTER_PAGE_HEADER*/}

            {/* END_USER_CODE-USER_AFTER_PAGE_HEADER*/}

            <Form noValidate className="row">
              {/* START_USER_CODE-USER_BEFORE_ExternalReceiptForfeituresSearch*/}

              {/* END_USER_CODE-USER_BEFORE_ExternalReceiptForfeituresSearch*/}

              {/* START_USER_CODE-USER_BEFORE_grpbxExternalReceiptForfeituresSearch*/}

              {/* END_USER_CODE-USER_BEFORE_grpbxExternalReceiptForfeituresSearch*/}

              <GroupBoxWidget
                conf={state.grpbxExternalReceiptForfeituresSearch}
                screenConf={state}
              >
                {/* START_USER_CODE-USER_BEFORE_grpbxDetails*/}

                {/* END_USER_CODE-USER_BEFORE_grpbxDetails*/}

                <GroupBoxWidget conf={state.grpbxDetails} screenConf={state}>
                  {/* START_USER_CODE-USER_BEFORE_txtFedBuyPtNum*/}

                  {/* END_USER_CODE-USER_BEFORE_txtFedBuyPtNum*/}

                  <TextBoxWidget
                    onChange={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    onBlur={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    values={values}
                    touched={touched}
                    errors={errors}
                    conf={state.txtFedBuyPtNum}
                    screenConf={state}
                    onPaste={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></TextBoxWidget>
                  {/* START_USER_CODE-USER_AFTER_txtFedBuyPtNum*/}

                  {/* END_USER_CODE-USER_AFTER_txtFedBuyPtNum*/}
                  {/* START_USER_CODE-USER_BEFORE_ddPeanutType*/}

                  {/* END_USER_CODE-USER_BEFORE_ddPeanutType*/}

                  <DropDownWidget
                    onChange={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    onBlur={handleBlur}
                    values={values}
                    touched={touched}
                    errors={errors}
                    conf={state.ddPeanutType}
                    screenConf={state}
                  ></DropDownWidget>
                  {/* START_USER_CODE-USER_AFTER_ddPeanutType*/}

                  {/* END_USER_CODE-USER_AFTER_ddPeanutType*/}
                  {/* START_USER_CODE-USER_BEFORE_txtReceiptNum*/}

                  {/* END_USER_CODE-USER_BEFORE_txtReceiptNum*/}

                  <TextBoxWidget
                    onChange={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    onBlur={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    values={values}
                    touched={touched}
                    errors={errors}
                    conf={state.txtReceiptNum}
                    screenConf={state}
                    onPaste={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></TextBoxWidget>
                  {/* START_USER_CODE-USER_AFTER_txtReceiptNum*/}

                  {/* END_USER_CODE-USER_AFTER_txtReceiptNum*/}
                  {/* START_USER_CODE-USER_BEFORE_txtDeliveryAgreementNum*/}

                  {/* END_USER_CODE-USER_BEFORE_txtDeliveryAgreementNum*/}

                  <TextBoxWidget
                    onChange={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    onBlur={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    values={values}
                    touched={touched}
                    errors={errors}
                    conf={state.txtDeliveryAgreementNum}
                    screenConf={state}
                    onPaste={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></TextBoxWidget>
                  {/* START_USER_CODE-USER_AFTER_txtDeliveryAgreementNum*/}

                  {/* END_USER_CODE-USER_AFTER_txtDeliveryAgreementNum*/}
                  {/* START_USER_CODE-USER_BEFORE_ddRecordStatus*/}

                  {/* END_USER_CODE-USER_BEFORE_ddRecordStatus*/}

                  <DropDownWidget
                    onChange={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    onBlur={handleBlur}
                    values={values}
                    touched={touched}
                    errors={errors}
                    conf={state.ddRecordStatus}
                    screenConf={state}
                  ></DropDownWidget>
                  {/* START_USER_CODE-USER_AFTER_ddRecordStatus*/}

                  {/* END_USER_CODE-USER_AFTER_ddRecordStatus*/}
                  {/* START_USER_CODE-USER_BEFORE_txtWarehouseCode*/}

                  {/* END_USER_CODE-USER_BEFORE_txtWarehouseCode*/}

                  <TextBoxWidget
                    onChange={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    onBlur={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    values={values}
                    touched={touched}
                    errors={errors}
                    conf={state.txtWarehouseCode}
                    screenConf={state}
                    onPaste={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></TextBoxWidget>
                  {/* START_USER_CODE-USER_AFTER_txtWarehouseCode*/}

                  {/* END_USER_CODE-USER_AFTER_txtWarehouseCode*/}
                </GroupBoxWidget>
                {/* START_USER_CODE-USER_AFTER_grpbxDetails*/}

                {/* END_USER_CODE-USER_AFTER_grpbxDetails*/}
                {/* START_USER_CODE-USER_BEFORE_grpbxSearchList*/}

                {/* END_USER_CODE-USER_BEFORE_grpbxSearchList*/}

                <GroupBoxWidget conf={state.grpbxSearchList} screenConf={state}>
                  {/* START_USER_CODE-USER_BEFORE_lblExternalReceiptForfeitureSearchList*/}

                  {/* END_USER_CODE-USER_BEFORE_lblExternalReceiptForfeitureSearchList*/}

                  <LabelWidget
                    values={values}
                    conf={state.lblExternalReceiptForfeitureSearchList}
                    screenConf={state}
                  ></LabelWidget>
                  {/* START_USER_CODE-USER_AFTER_lblExternalReceiptForfeitureSearchList*/}

                  {/* END_USER_CODE-USER_AFTER_lblExternalReceiptForfeitureSearchList*/}
                  {/* START_USER_CODE-USER_BEFORE_btnSearch*/}

                  {/* END_USER_CODE-USER_BEFORE_btnSearch*/}

                  <ButtonWidget
                    conf={state.btnSearch}
                    screenConf={state}
                    onClick={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></ButtonWidget>
                  {/* START_USER_CODE-USER_AFTER_btnSearch*/}

                  {/* END_USER_CODE-USER_AFTER_btnSearch*/}
                  {/* START_USER_CODE-USER_BEFORE_lblCropYear*/}

                  {/* END_USER_CODE-USER_BEFORE_lblCropYear*/}

                  <LabelWidget
                    values={values}
                    conf={state.lblCropYear}
                    screenConf={state}
                  ></LabelWidget>
                  {/* START_USER_CODE-USER_AFTER_lblCropYear*/}

                  {/* END_USER_CODE-USER_AFTER_lblCropYear*/}
                  {/* START_USER_CODE-USER_BEFORE_chkboxShowAllFields*/}

                  {/* END_USER_CODE-USER_BEFORE_chkboxShowAllFields*/}

                  <CheckboxWidget
                    onChange={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    onBlur={handleBlur}
                    values={values}
                    touched={touched}
                    errors={errors}
                    conf={state.chkboxShowAllFields}
                    screenConf={state}
                  ></CheckboxWidget>
                  {/* START_USER_CODE-USER_AFTER_chkboxShowAllFields*/}

                  {/* END_USER_CODE-USER_AFTER_chkboxShowAllFields*/}
                  {/* START_USER_CODE-USER_BEFORE_btnCreate*/}

                  {/* END_USER_CODE-USER_BEFORE_btnCreate*/}

                  <ButtonWidget
                    conf={state.btnCreate}
                    screenConf={state}
                    onClick={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></ButtonWidget>
                  {/* START_USER_CODE-USER_AFTER_btnCreate*/}

                  {/* END_USER_CODE-USER_AFTER_btnCreate*/}
                  {/* START_USER_CODE-USER_BEFORE_btnOpen*/}

                  {/* END_USER_CODE-USER_BEFORE_btnOpen*/}

                  <ButtonWidget
                    conf={state.btnOpen}
                    screenConf={state}
                    onClick={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></ButtonWidget>
                  {/* START_USER_CODE-USER_AFTER_btnOpen*/}

                  {/* END_USER_CODE-USER_AFTER_btnOpen*/}
                  {/* START_USER_CODE-USER_BEFORE_gridExternalReceiptForfeitureSearchList*/}

                  {/* END_USER_CODE-USER_BEFORE_gridExternalReceiptForfeitureSearchList*/}

                  <GridWidget
                    conf={state.gridExternalReceiptForfeitureSearchList}
                    screenConf={state}
                    linkClick={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    errors={errors}
                    touched={touched}
                    rows={values.gridExternalReceiptForfeitureSearchList}
                    onEvent={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></GridWidget>
                  {/* START_USER_CODE-USER_AFTER_gridExternalReceiptForfeitureSearchList*/}

                  {/* END_USER_CODE-USER_AFTER_gridExternalReceiptForfeitureSearchList*/}
                  {/* START_USER_CODE-USER_BEFORE_txtTotalPounds*/}

                  {/* END_USER_CODE-USER_BEFORE_txtTotalPounds*/}

                  <TextBoxWidget
                    onChange={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    onBlur={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    values={values}
                    touched={touched}
                    errors={errors}
                    conf={state.txtTotalPounds}
                    screenConf={state}
                    onPaste={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></TextBoxWidget>
                  {/* START_USER_CODE-USER_AFTER_txtTotalPounds*/}

                  {/* END_USER_CODE-USER_AFTER_txtTotalPounds*/}
                  {/* START_USER_CODE-USER_BEFORE_txtTotalReceiptValue*/}

                  {/* END_USER_CODE-USER_BEFORE_txtTotalReceiptValue*/}

                  <TextBoxWidget
                    onChange={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    onBlur={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                    values={values}
                    touched={touched}
                    errors={errors}
                    conf={state.txtTotalReceiptValue}
                    screenConf={state}
                    onPaste={event =>
                      invokeEventHandler(
                        event,
                        handleChange,
                        handleBlur,
                        thisObj
                      )
                    }
                  ></TextBoxWidget>
                  {/* START_USER_CODE-USER_AFTER_txtTotalReceiptValue*/}

                  {/* END_USER_CODE-USER_AFTER_txtTotalReceiptValue*/}
                </GroupBoxWidget>
                {/* START_USER_CODE-USER_AFTER_grpbxSearchList*/}

                {/* END_USER_CODE-USER_AFTER_grpbxSearchList*/}
              </GroupBoxWidget>
              {/* START_USER_CODE-USER_AFTER_grpbxExternalReceiptForfeituresSearch*/}

              {/* END_USER_CODE-USER_AFTER_grpbxExternalReceiptForfeituresSearch*/}
              {/* START_USER_CODE-USER_BEFORE_cmmndCntnrActions*/}

              {/* END_USER_CODE-USER_BEFORE_cmmndCntnrActions*/}
              <img
                src={StripPic}
                  className="stripDesign"
                />
              <CommandContainerWidget
                conf={state.cmmndCntnrActions}
                screenConf={state}
              >
                {/* START_USER_CODE-USER_BEFORE_btnClose*/}

                {/* END_USER_CODE-USER_BEFORE_btnClose*/}

                <ButtonWidget
                  conf={state.btnClose}
                  screenConf={state}
                  onClick={event =>
                    invokeEventHandler(event, handleChange, handleBlur, thisObj)
                  }
                ></ButtonWidget>
                {/* START_USER_CODE-USER_AFTER_btnClose*/}

                {/* END_USER_CODE-USER_AFTER_btnClose*/}
                {/* START_USER_CODE-USER_BEFORE_btnPrintSearch*/}

                {/* END_USER_CODE-USER_BEFORE_btnPrintSearch*/}

                <ButtonWidget
                  conf={state.btnPrintSearch}
                  screenConf={state}
                  onClick={event =>
                    invokeEventHandler(event, handleChange, handleBlur, thisObj)
                  }
                ></ButtonWidget>
                {/* START_USER_CODE-USER_AFTER_btnPrintSearch*/}

                {/* END_USER_CODE-USER_AFTER_btnPrintSearch*/}
              </CommandContainerWidget>
              {/* START_USER_CODE-USER_AFTER_cmmndCntnrActions*/}

              {/* END_USER_CODE-USER_AFTER_cmmndCntnrActions*/}

              {/* START_USER_CODE-USER_AFTER_ExternalReceiptForfeituresSearch*/}

              {/* END_USER_CODE-USER_AFTER_ExternalReceiptForfeituresSearch*/}
            </Form>
          </div>
        );
      }}
    </Formik>
  );
}
export default withRouter(WarehouseReceipts_ExternalReceiptForfeituresSearch);
